/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { AccessTokenError } from '../model/accessTokenError';
import { AccountDetailResponseMap } from '../model/accountDetailResponseMap';
import { ActionCardData } from '../model/actionCardData';
import { ActiveRoleRequestInfo } from '../model/activeRoleRequestInfo';
import { ActiveRoleResponseInfo } from '../model/activeRoleResponseInfo';
import { ActivityResponseInfoList } from '../model/activityResponseInfoList';
import { ActivityResponseInfoList2 } from '../model/activityResponseInfoList2';
import { ActivityResponseInfoList3 } from '../model/activityResponseInfoList3';
import { ActivityResponseInfoList4 } from '../model/activityResponseInfoList4';
import { ActivityResponseInfoList5 } from '../model/activityResponseInfoList5';
import { AdminInfo2 } from '../model/adminInfo2';
import { ApiAuthenticationCreateRequestType } from '../model/apiAuthenticationCreateRequestType';
import { ApiAuthenticationResponseType } from '../model/apiAuthenticationResponseType';
import { ApiAuthenticationResponseType2 } from '../model/apiAuthenticationResponseType2';
import { ApiAuthenticationResponseTypeList } from '../model/apiAuthenticationResponseTypeList';
import { ApiAuthenticationUpdateRequestType } from '../model/apiAuthenticationUpdateRequestType';
import { AppResponseInfoList } from '../model/appResponseInfoList';
import { AutoPayEnrollRequest } from '../model/autoPayEnrollRequest';
import { AutoPayEnrollRequest2 } from '../model/autoPayEnrollRequest2';
import { AutoPayEnrollRequest3 } from '../model/autoPayEnrollRequest3';
import { AutoPayEnrollResponse } from '../model/autoPayEnrollResponse';
import { AutoPayEnrollResponse2 } from '../model/autoPayEnrollResponse2';
import { AutoPayEnrollResponse3 } from '../model/autoPayEnrollResponse3';
import { AutoPayEnrollResponse4 } from '../model/autoPayEnrollResponse4';
import { AutoPayEnrollResponse5 } from '../model/autoPayEnrollResponse5';
import { ChangeRequestRequest } from '../model/changeRequestRequest';
import { ChangeRequestResponse } from '../model/changeRequestResponse';
import { ChartDataRequest } from '../model/chartDataRequest';
import { ChartDataResponseList } from '../model/chartDataResponseList';
import { ChartResponseInfoList } from '../model/chartResponseInfoList';
import { CloneInquiryRequestInfo } from '../model/cloneInquiryRequestInfo';
import { CloneInquiryResponseInfo } from '../model/cloneInquiryResponseInfo';
import { CloneRequestInfo } from '../model/cloneRequestInfo';
import { ConfigResponseInfoList } from '../model/configResponseInfoList';
import { ConfigSummaryRequestInfo } from '../model/configSummaryRequestInfo';
import { ConfigSummaryResponseInfo } from '../model/configSummaryResponseInfo';
import { ConfigValueCreateRequestInfo } from '../model/configValueCreateRequestInfo';
import { ConfigValueHistoryResponseInfo } from '../model/configValueHistoryResponseInfo';
import { ConfigValueHistoryRetrieveRequestInfo } from '../model/configValueHistoryRetrieveRequestInfo';
import { ConfigValueResponseInfo } from '../model/configValueResponseInfo';
import { ConfigValueResponseInfo2 } from '../model/configValueResponseInfo2';
import { ConfigValueRetriveByKeysRequestInfo } from '../model/configValueRetriveByKeysRequestInfo';
import { ConfigValueRetriveByKeysResponseInfo } from '../model/configValueRetriveByKeysResponseInfo';
import { ConfigValueUpdateRequestInfo } from '../model/configValueUpdateRequestInfo';
import { ConsumerActionResponse } from '../model/consumerActionResponse';
import { ConsumerActityCreateRequestInfo } from '../model/consumerActityCreateRequestInfo';
import { ConsumerActityCreateRequestInfo2 } from '../model/consumerActityCreateRequestInfo2';
import { ConsumerActityCreateResponseInfo } from '../model/consumerActityCreateResponseInfo';
import { ConsumerActityCreateResponseInfo2 } from '../model/consumerActityCreateResponseInfo2';
import { ConsumerActityCreateResponseInfo3 } from '../model/consumerActityCreateResponseInfo3';
import { ConsumerAttributesRespInfo } from '../model/consumerAttributesRespInfo';
import { ConsumerCreateInputRequest } from '../model/consumerCreateInputRequest';
import { ConsumerCreateResponse } from '../model/consumerCreateResponse';
import { ConsumerDataRequest } from '../model/consumerDataRequest';
import { ConsumerDataRequestMap } from '../model/consumerDataRequestMap';
import { ConsumerDataResponse } from '../model/consumerDataResponse';
import { ConsumerDataResponseMap } from '../model/consumerDataResponseMap';
import { ConsumerLinkRequestMap } from '../model/consumerLinkRequestMap';
import { ConsumerLinkResponseMap } from '../model/consumerLinkResponseMap';
import { ConsumerPatchRequest } from '../model/consumerPatchRequest';
import { ConsumerRegistrationResponse } from '../model/consumerRegistrationResponse';
import { ConsumerRetrieveResponse } from '../model/consumerRetrieveResponse';
import { ConsumerSearchRequestInfo } from '../model/consumerSearchRequestInfo';
import { ConsumerSearchResponseInfo } from '../model/consumerSearchResponseInfo';
import { ConsumerTokenAuthRequest } from '../model/consumerTokenAuthRequest';
import { ConsumerTokenAuthResponse } from '../model/consumerTokenAuthResponse';
import { ConsumerUnLinkRequestMap } from '../model/consumerUnLinkRequestMap';
import { ConsumerUnLinkResponseMap } from '../model/consumerUnLinkResponseMap';
import { CountryLookupResponseInfo } from '../model/countryLookupResponseInfo';
import { DatamapResponseList } from '../model/datamapResponseList';
import { DbDefinitionResponseList } from '../model/dbDefinitionResponseList';
import { DeviceCreateRequestInfo } from '../model/deviceCreateRequestInfo';
import { DeviceCreateResponseInfo } from '../model/deviceCreateResponseInfo';
import { DeviceResponseInfo } from '../model/deviceResponseInfo';
import { DeviceRetrieveAllResponse } from '../model/deviceRetrieveAllResponse';
import { DeviceUpdateRequestInfo } from '../model/deviceUpdateRequestInfo';
import { DeviceUpdateResponseInfo } from '../model/deviceUpdateResponseInfo';
import { DownloadRequestInfo } from '../model/downloadRequestInfo';
import { EncryptionRequestInfo } from '../model/encryptionRequestInfo';
import { EncryptionResponseInfo } from '../model/encryptionResponseInfo';
import { ErrorMessage } from '../model/errorMessage';
import { FacilityDeptAddRequestInfo } from '../model/facilityDeptAddRequestInfo';
import { FacilityDeptAddRespInfo } from '../model/facilityDeptAddRespInfo';
import { FacilityDeptCreateRequestInfo } from '../model/facilityDeptCreateRequestInfo';
import { FacilityDeptInactiveRequestInfo } from '../model/facilityDeptInactiveRequestInfo';
import { FacilityDeptInactiveResponseInfo } from '../model/facilityDeptInactiveResponseInfo';
import { FacilityDeptRemoveRequestInfo } from '../model/facilityDeptRemoveRequestInfo';
import { FacilityDeptResponseInfo } from '../model/facilityDeptResponseInfo';
import { FacilityDeptResponseInfo2 } from '../model/facilityDeptResponseInfo2';
import { FacilityDeptResponseInfoList } from '../model/facilityDeptResponseInfoList';
import { FacilityDeptResponseInfoList2 } from '../model/facilityDeptResponseInfoList2';
import { FacilityDeptRetrieveResponseInfo } from '../model/facilityDeptRetrieveResponseInfo';
import { FacilityDeptUpdateRequestInfo } from '../model/facilityDeptUpdateRequestInfo';
import { GroupCreateRequestInfo } from '../model/groupCreateRequestInfo';
import { GroupDeviceCreateRequestInfo } from '../model/groupDeviceCreateRequestInfo';
import { GroupDeviceCreateRequestInfo2 } from '../model/groupDeviceCreateRequestInfo2';
import { GroupDeviceCreateResponseInfo } from '../model/groupDeviceCreateResponseInfo';
import { GroupDeviceResponseInfoList } from '../model/groupDeviceResponseInfoList';
import { GroupDeviceRetrieveAllResponse } from '../model/groupDeviceRetrieveAllResponse';
import { GroupDeviceUpdateRequestInfo } from '../model/groupDeviceUpdateRequestInfo';
import { GroupDeviceUpdateResponseInfo } from '../model/groupDeviceUpdateResponseInfo';
import { GroupHierarchyResponseInfo } from '../model/groupHierarchyResponseInfo';
import { GroupResponseInfo } from '../model/groupResponseInfo';
import { GroupResponseInfo2 } from '../model/groupResponseInfo2';
import { GroupResponseInfoList } from '../model/groupResponseInfoList';
import { GroupResponseSiteNameList } from '../model/groupResponseSiteNameList';
import { GroupRetrieveAllResponseInfo } from '../model/groupRetrieveAllResponseInfo';
import { GroupRetrieveAllResponseInfo2 } from '../model/groupRetrieveAllResponseInfo2';
import { GroupRetrieveSubAccountRespInfo } from '../model/groupRetrieveSubAccountRespInfo';
import { GroupRetrieveSubGroupResponseInfo } from '../model/groupRetrieveSubGroupResponseInfo';
import { GroupUpdateRequestInfo } from '../model/groupUpdateRequestInfo';
import { InactiveResponse } from '../model/inactiveResponse';
import { InactiveRoleRequestInfo } from '../model/inactiveRoleRequestInfo';
import { InactiveRoleResponseInfo } from '../model/inactiveRoleResponseInfo';
import { InlineResponse2003 } from '../model/inlineResponse2003';
import { OrgCreateRequestInfo } from '../model/orgCreateRequestInfo';
import { OrgFacilityCreateRequestInfo } from '../model/orgFacilityCreateRequestInfo';
import { OrgFacilityResponseInfo } from '../model/orgFacilityResponseInfo';
import { OrgFacilityResponseInfoList } from '../model/orgFacilityResponseInfoList';
import { OrgFacilityRetrieveResponseInfo } from '../model/orgFacilityRetrieveResponseInfo';
import { OrgFacilityUpdateRequestInfo } from '../model/orgFacilityUpdateRequestInfo';
import { OrgFacilityUpdateResponseInfo } from '../model/orgFacilityUpdateResponseInfo';
import { OrgResponseInfo } from '../model/orgResponseInfo';
import { OrgResponseInfo2 } from '../model/orgResponseInfo2';
import { OrgResponseInfoList } from '../model/orgResponseInfoList';
import { OrgResponseInfoList2 } from '../model/orgResponseInfoList2';
import { OrgResponseSiteNameList } from '../model/orgResponseSiteNameList';
import { OrgRetrieveResponseInfo } from '../model/orgRetrieveResponseInfo';
import { OrgUpdateRequestInfo } from '../model/orgUpdateRequestInfo';
import { PaymentAgreementResponse } from '../model/paymentAgreementResponse';
import { PaymentOptionRequest } from '../model/paymentOptionRequest';
import { PaymentOptionResponse } from '../model/paymentOptionResponse';
import { PaymentPlanOptionsResponse } from '../model/paymentPlanOptionsResponse';
import { PaymentPlanResponse } from '../model/paymentPlanResponse';
import { PermissionResponseInfoList } from '../model/permissionResponseInfoList';
import { PurgeDataRequestInfo } from '../model/purgeDataRequestInfo';
import { Request1 } from '../model/request1';
import { Request2 } from '../model/request2';
import { Request3 } from '../model/request3';
import { Request4 } from '../model/request4';
import { Request5 } from '../model/request5';
import { Request6 } from '../model/request6';
import { RoleCreateRequestInfo } from '../model/roleCreateRequestInfo';
import { RoleCreateRequestInfo2 } from '../model/roleCreateRequestInfo2';
import { RoleCreateRequestInfo3 } from '../model/roleCreateRequestInfo3';
import { RoleResponseInfo } from '../model/roleResponseInfo';
import { RoleResponseInfo2 } from '../model/roleResponseInfo2';
import { RoleResponseInfo3 } from '../model/roleResponseInfo3';
import { RoleResponseInfoList } from '../model/roleResponseInfoList';
import { SmartActionsResponse } from '../model/smartActionsResponse';
import { SmartActionsResponse2 } from '../model/smartActionsResponse2';
import { StateLookupResponseInfo } from '../model/stateLookupResponseInfo';
import { SurveyNextQuestionRequestInfo } from '../model/surveyNextQuestionRequestInfo';
import { SurveyNextQuestionResponseInfo } from '../model/surveyNextQuestionResponseInfo';
import { SurveyRetrieveAllResponseInfo } from '../model/surveyRetrieveAllResponseInfo';
import { SurveyStartRequestInfo } from '../model/surveyStartRequestInfo';
import { SurveyStartResponseInfo } from '../model/surveyStartResponseInfo';
import { SyncAndVerificationResponseInfo } from '../model/syncAndVerificationResponseInfo';
import { TerminalDeviceResponseInfo } from '../model/terminalDeviceResponseInfo';
import { TerminalRequestInfo } from '../model/terminalRequestInfo';
import { TerminalResponseInfo } from '../model/terminalResponseInfo';
import { TerminalResponseInfo2 } from '../model/terminalResponseInfo2';
import { TerminalResponseInfoList } from '../model/terminalResponseInfoList';
import { UrlResolverResponse } from '../model/urlResolverResponse';
import { UrlShortenerRequest } from '../model/urlShortenerRequest';
import { UrlShortenerResponse } from '../model/urlShortenerResponse';
import { ValidateSettingRequestInfo } from '../model/validateSettingRequestInfo';
import { ValidateSettingResponseInfo } from '../model/validateSettingResponseInfo';
import { VerificationCheckResponse } from '../model/verificationCheckResponse';
import { VerificationCheckResponse2 } from '../model/verificationCheckResponse2';
import { VerificationRequest } from '../model/verificationRequest';
import { VerificationResponse } from '../model/verificationResponse';
import { VerificationRetrieveResponse } from '../model/verificationRetrieveResponse';
import { VwConfigRequestInfoList } from '../model/vwConfigRequestInfoList';
import { VwConfigResponseInfoList } from '../model/vwConfigResponseInfoList';
import { WebAuthenticationCreateRequestInfo } from '../model/webAuthenticationCreateRequestInfo';
import { WebAuthenticationCreateRequestInfo2 } from '../model/webAuthenticationCreateRequestInfo2';
import { WebAuthenticationResponseInfo } from '../model/webAuthenticationResponseInfo';
import { WebAuthenticationResponseInfo2 } from '../model/webAuthenticationResponseInfo2';
import { WebAuthenticationResponseInfoList } from '../model/webAuthenticationResponseInfoList';
import { ZipcodeLookupResponseInfo } from '../model/zipcodeLookupResponseInfo';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class OrgMgrService {
    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string,
        @Optional() configuration: Configuration,
    ) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    /**
     * OrgMgr_RetrieveAllActivity, Retrieve all activities
     * Retrieve all activities
     * @param Level Enter the Level
     * @param OrgId Enter the OrgId
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ActivityGet(
        Level: string,
        OrgId?: number,
        GroupId?: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ActivityResponseInfoList>;
    public orgMgrV1ActivityGet(
        Level: string,
        OrgId?: number,
        GroupId?: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ActivityResponseInfoList>>;
    public orgMgrV1ActivityGet(
        Level: string,
        OrgId?: number,
        GroupId?: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ActivityResponseInfoList>>;
    public orgMgrV1ActivityGet(
        Level: string,
        OrgId?: number,
        GroupId?: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Level === null || Level === undefined) {
            throw new Error('Required parameter Level was null or undefined when calling orgMgrV1ActivityGet.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (Level !== undefined) {
            queryParameters = queryParameters.set('Level', <any>Level);
        }
        if (OrgId !== undefined) {
            queryParameters = queryParameters.set('OrgId', <any>OrgId);
        }
        if (GroupId !== undefined) {
            queryParameters = queryParameters.set('GroupId', <any>GroupId);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ActivityResponseInfoList>(`${this.basePath}/OrgMgr/V1/Activity`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_AdminInfo, Get the Admin Info
     * Gives the latest Version Control and Host Info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1AdminInfoGet(observe?: 'body', reportProgress?: boolean): Observable<AdminInfo2>;
    public orgMgrV1AdminInfoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminInfo2>>;
    public orgMgrV1AdminInfoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminInfo2>>;
    public orgMgrV1AdminInfoGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<AdminInfo2>(`${this.basePath}/OrgMgr/V1/Admin/Info`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveAllApiAuthentication, Retrieve All ApiAuthentication
     * Retrieve All ApiAuthentication
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ApiAuthenticationGet(
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ApiAuthenticationResponseTypeList>;
    public orgMgrV1ApiAuthenticationGet(
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ApiAuthenticationResponseTypeList>>;
    public orgMgrV1ApiAuthenticationGet(
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ApiAuthenticationResponseTypeList>>;
    public orgMgrV1ApiAuthenticationGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ApiAuthenticationResponseTypeList>(`${this.basePath}/OrgMgr/V1/ApiAuthentication`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_DeleteApiAuthentication, Delete ApiAuthentication
     * Delete ApiAuthentication
     * @param Id Enter the ApiAuthentication Id that needs to be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ApiAuthenticationIdDelete(
        Id: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ApiAuthenticationResponseType2>;
    public orgMgrV1ApiAuthenticationIdDelete(
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ApiAuthenticationResponseType2>>;
    public orgMgrV1ApiAuthenticationIdDelete(
        Id: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ApiAuthenticationResponseType2>>;
    public orgMgrV1ApiAuthenticationIdDelete(
        Id: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error(
                'Required parameter Id was null or undefined when calling orgMgrV1ApiAuthenticationIdDelete.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.delete<ApiAuthenticationResponseType2>(
            `${this.basePath}/OrgMgr/V1/ApiAuthentication/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_UpdateApiAuthentication, Update ApiAuthentication
     * Update ApiAuthentication
     * @param Id Enter the ApiAuthentication Id that needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ApiAuthenticationIdPut(
        Id: number,
        Request: ApiAuthenticationUpdateRequestType,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ApiAuthenticationResponseType2>;
    public orgMgrV1ApiAuthenticationIdPut(
        Id: number,
        Request: ApiAuthenticationUpdateRequestType,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ApiAuthenticationResponseType2>>;
    public orgMgrV1ApiAuthenticationIdPut(
        Id: number,
        Request: ApiAuthenticationUpdateRequestType,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ApiAuthenticationResponseType2>>;
    public orgMgrV1ApiAuthenticationIdPut(
        Id: number,
        Request: ApiAuthenticationUpdateRequestType,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1ApiAuthenticationIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ApiAuthenticationIdPut.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<ApiAuthenticationResponseType2>(
            `${this.basePath}/OrgMgr/V1/ApiAuthentication/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateApiAuthentication, Create ApiAuthentication
     * Create ApiAuthentication
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ApiAuthenticationPost(
        Request: ApiAuthenticationCreateRequestType,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ApiAuthenticationResponseType>;
    public orgMgrV1ApiAuthenticationPost(
        Request: ApiAuthenticationCreateRequestType,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ApiAuthenticationResponseType>>;
    public orgMgrV1ApiAuthenticationPost(
        Request: ApiAuthenticationCreateRequestType,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ApiAuthenticationResponseType>>;
    public orgMgrV1ApiAuthenticationPost(
        Request: ApiAuthenticationCreateRequestType,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ApiAuthenticationPost.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApiAuthenticationResponseType>(
            `${this.basePath}/OrgMgr/V1/ApiAuthentication`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_AssignDefaultRolePermission, Assign role to permission
     * Assign role to permission
     * @param AppName Enter the AppName
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1AppAssignDefaultRolePermissionPut(
        AppName: string,
        Request: RoleCreateRequestInfo3,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<RoleResponseInfo3>;
    public orgMgrV1AppAssignDefaultRolePermissionPut(
        AppName: string,
        Request: RoleCreateRequestInfo3,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<RoleResponseInfo3>>;
    public orgMgrV1AppAssignDefaultRolePermissionPut(
        AppName: string,
        Request: RoleCreateRequestInfo3,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<RoleResponseInfo3>>;
    public orgMgrV1AppAssignDefaultRolePermissionPut(
        AppName: string,
        Request: RoleCreateRequestInfo3,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (AppName === null || AppName === undefined) {
            throw new Error(
                'Required parameter AppName was null or undefined when calling orgMgrV1AppAssignDefaultRolePermissionPut.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1AppAssignDefaultRolePermissionPut.',
            );
        }

        let headers = this.defaultHeaders;
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<RoleResponseInfo3>(
            `${this.basePath}/OrgMgr/V1/App/AssignDefaultRolePermission`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_RetrieveAllApp, Get all Apps
     * Get all Apps
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1AppGet(observe?: 'body', reportProgress?: boolean): Observable<AppResponseInfoList>;
    public orgMgrV1AppGet(
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<AppResponseInfoList>>;
    public orgMgrV1AppGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AppResponseInfoList>>;
    public orgMgrV1AppGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<AppResponseInfoList>(`${this.basePath}/OrgMgr/V1/App`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_ActiveRole, Active the role
     * Active the role
     * @param GroupId Enter the GroupId
     * @param AppName Enter the AppName
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1AppRoleActivePost(
        GroupId: number,
        AppName: string,
        Request: ActiveRoleRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ActiveRoleResponseInfo>;
    public orgMgrV1AppRoleActivePost(
        GroupId: number,
        AppName: string,
        Request: ActiveRoleRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ActiveRoleResponseInfo>>;
    public orgMgrV1AppRoleActivePost(
        GroupId: number,
        AppName: string,
        Request: ActiveRoleRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ActiveRoleResponseInfo>>;
    public orgMgrV1AppRoleActivePost(
        GroupId: number,
        AppName: string,
        Request: ActiveRoleRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1AppRoleActivePost.');
        }
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrV1AppRoleActivePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1AppRoleActivePost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ActiveRoleResponseInfo>(`${this.basePath}/OrgMgr/V1/App/Role/Active`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveAllRole, Retrieve all Role
     * Retrieve all Role
     * @param GroupId Enter the GroupId
     * @param AppName Enter the AppName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1AppRoleGet(
        GroupId: number,
        AppName: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<RoleResponseInfoList>;
    public orgMgrV1AppRoleGet(
        GroupId: number,
        AppName: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<RoleResponseInfoList>>;
    public orgMgrV1AppRoleGet(
        GroupId: number,
        AppName: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<RoleResponseInfoList>>;
    public orgMgrV1AppRoleGet(
        GroupId: number,
        AppName: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1AppRoleGet.');
        }
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrV1AppRoleGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<RoleResponseInfoList>(`${this.basePath}/OrgMgr/V1/App/Role`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_DeleteRole, Delete the requested Role
     * Delete the requested Role
     * @param Id Enter the role id that needs to be deleted
     * @param GroupId Enter the GroupId
     * @param AppName Enter the AppName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1AppRoleIdDelete(
        Id: number,
        GroupId: number,
        AppName: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<any>;
    public orgMgrV1AppRoleIdDelete(
        Id: number,
        GroupId: number,
        AppName: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1AppRoleIdDelete(
        Id: number,
        GroupId: number,
        AppName: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1AppRoleIdDelete(
        Id: number,
        GroupId: number,
        AppName: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1AppRoleIdDelete.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1AppRoleIdDelete.');
        }
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrV1AppRoleIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/V1/App/Role/${encodeURIComponent(String(Id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveRole, Retrieve Role by Id
     * Retrieve Role by Id
     * @param GroupId Enter the GroupId
     * @param AppName Enter the AppName
     * @param Id Enter the Id for which Role needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1AppRoleIdGet(
        GroupId: number,
        AppName: string,
        Id: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<RoleResponseInfo2>;
    public orgMgrV1AppRoleIdGet(
        GroupId: number,
        AppName: string,
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<RoleResponseInfo2>>;
    public orgMgrV1AppRoleIdGet(
        GroupId: number,
        AppName: string,
        Id: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<RoleResponseInfo2>>;
    public orgMgrV1AppRoleIdGet(
        GroupId: number,
        AppName: string,
        Id: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1AppRoleIdGet.');
        }
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrV1AppRoleIdGet.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1AppRoleIdGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<RoleResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/App/Role/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_InactiveRole, Inactive the role
     * Inactive the role and move the existing users to given RoleId in request
     * @param Id Enter the existing roleId
     * @param GroupId Enter the Super parent GroupId
     * @param AppName Enter the AppName
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1AppRoleIdInactivePut(
        Id: number,
        GroupId: number,
        AppName: string,
        Request: InactiveRoleRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<InactiveRoleResponseInfo>;
    public orgMgrV1AppRoleIdInactivePut(
        Id: number,
        GroupId: number,
        AppName: string,
        Request: InactiveRoleRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<InactiveRoleResponseInfo>>;
    public orgMgrV1AppRoleIdInactivePut(
        Id: number,
        GroupId: number,
        AppName: string,
        Request: InactiveRoleRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<InactiveRoleResponseInfo>>;
    public orgMgrV1AppRoleIdInactivePut(
        Id: number,
        GroupId: number,
        AppName: string,
        Request: InactiveRoleRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1AppRoleIdInactivePut.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1AppRoleIdInactivePut.',
            );
        }
        if (AppName === null || AppName === undefined) {
            throw new Error(
                'Required parameter AppName was null or undefined when calling orgMgrV1AppRoleIdInactivePut.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1AppRoleIdInactivePut.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<InactiveRoleResponseInfo>(
            `${this.basePath}/OrgMgr/V1/App/Role/${encodeURIComponent(String(Id))}/Inactive`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_UpdateRole, Update a Role
     * Update a Role
     * @param Id Enter the Id for which Role needs to be updated
     * @param GroupId Enter the GroupId
     * @param AppName Enter the AppName
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1AppRoleIdPatch(
        Id: number,
        GroupId: number,
        AppName: string,
        Request: RoleCreateRequestInfo2,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<RoleResponseInfo2>;
    public orgMgrV1AppRoleIdPatch(
        Id: number,
        GroupId: number,
        AppName: string,
        Request: RoleCreateRequestInfo2,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<RoleResponseInfo2>>;
    public orgMgrV1AppRoleIdPatch(
        Id: number,
        GroupId: number,
        AppName: string,
        Request: RoleCreateRequestInfo2,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<RoleResponseInfo2>>;
    public orgMgrV1AppRoleIdPatch(
        Id: number,
        GroupId: number,
        AppName: string,
        Request: RoleCreateRequestInfo2,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1AppRoleIdPatch.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1AppRoleIdPatch.');
        }
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrV1AppRoleIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1AppRoleIdPatch.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<RoleResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/App/Role/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateRole, Create a Role
     * Create a Role
     * @param GroupId Enter the GroupId
     * @param AppName Enter the AppName
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1AppRolePost(
        GroupId: number,
        AppName: string,
        Request: RoleCreateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<RoleResponseInfo>;
    public orgMgrV1AppRolePost(
        GroupId: number,
        AppName: string,
        Request: RoleCreateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<RoleResponseInfo>>;
    public orgMgrV1AppRolePost(
        GroupId: number,
        AppName: string,
        Request: RoleCreateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<RoleResponseInfo>>;
    public orgMgrV1AppRolePost(
        GroupId: number,
        AppName: string,
        Request: RoleCreateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1AppRolePost.');
        }
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrV1AppRolePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1AppRolePost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<RoleResponseInfo>(`${this.basePath}/OrgMgr/V1/App/Role`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveChartData, Retrieve Chart Data
     * Retrieve Chart Data
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ChartDataPost(
        Request: ChartDataRequest,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ChartDataResponseList>;
    public orgMgrV1ChartDataPost(
        Request: ChartDataRequest,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ChartDataResponseList>>;
    public orgMgrV1ChartDataPost(
        Request: ChartDataRequest,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ChartDataResponseList>>;
    public orgMgrV1ChartDataPost(
        Request: ChartDataRequest,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1ChartDataPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ChartDataResponseList>(`${this.basePath}/OrgMgr/V1/Chart/Data`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveAllChart, Retrieve all Chart
     * Retrieve all Chart
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ChartGet(observe?: 'body', reportProgress?: boolean): Observable<ChartResponseInfoList>;
    public orgMgrV1ChartGet(
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ChartResponseInfoList>>;
    public orgMgrV1ChartGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChartResponseInfoList>>;
    public orgMgrV1ChartGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ChartResponseInfoList>(`${this.basePath}/OrgMgr/V1/Chart`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_CloneInquiry, Inquiry of Cloning SiteSetting/Config
     * Inquiry to Clone the SiteSetting/Config based on Key names and OrgId or GroupId
     * @param request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1CloneInquiryPost(
        request: CloneInquiryRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<CloneInquiryResponseInfo>;
    public orgMgrV1CloneInquiryPost(
        request: CloneInquiryRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<CloneInquiryResponseInfo>>;
    public orgMgrV1CloneInquiryPost(
        request: CloneInquiryRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<CloneInquiryResponseInfo>>;
    public orgMgrV1CloneInquiryPost(
        request: CloneInquiryRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling orgMgrV1CloneInquiryPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CloneInquiryResponseInfo>(`${this.basePath}/OrgMgr/V1/Clone/Inquiry`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_Clone, Clone the SiteSetting/Config
     * Clone the SiteSetting/Config based on Key names and OrgId or GroupId
     * @param request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ClonePost(request: CloneRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrV1ClonePost(
        request: CloneRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1ClonePost(
        request: CloneRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1ClonePost(
        request: CloneRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling orgMgrV1ClonePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/OrgMgr/V1/Clone`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveAllConfig, Get the Config
     * Get the Config
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConfigGet(observe?: 'body', reportProgress?: boolean): Observable<ConfigResponseInfoList>;
    public orgMgrV1ConfigGet(
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConfigResponseInfoList>>;
    public orgMgrV1ConfigGet(
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConfigResponseInfoList>>;
    public orgMgrV1ConfigGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ConfigResponseInfoList>(`${this.basePath}/OrgMgr/V1/Config`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveConfigByKey, Get the Config based on keys
     * Get the Config based on Id
     * @param request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConfigPost(
        request: VwConfigRequestInfoList,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<VwConfigResponseInfoList>;
    public orgMgrV1ConfigPost(
        request: VwConfigRequestInfoList,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<VwConfigResponseInfoList>>;
    public orgMgrV1ConfigPost(
        request: VwConfigRequestInfoList,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<VwConfigResponseInfoList>>;
    public orgMgrV1ConfigPost(
        request: VwConfigRequestInfoList,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling orgMgrV1ConfigPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<VwConfigResponseInfoList>(`${this.basePath}/OrgMgr/V1/Config`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_ConfigSummary, Get Config Summary
     * Get Config Summary
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConfigSummaryPost(
        Request: ConfigSummaryRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConfigSummaryResponseInfo>;
    public orgMgrV1ConfigSummaryPost(
        Request: ConfigSummaryRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConfigSummaryResponseInfo>>;
    public orgMgrV1ConfigSummaryPost(
        Request: ConfigSummaryRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConfigSummaryResponseInfo>>;
    public orgMgrV1ConfigSummaryPost(
        Request: ConfigSummaryRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1ConfigSummaryPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConfigSummaryResponseInfo>(`${this.basePath}/OrgMgr/V1/Config/Summary`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_ConfigValueHistoryDownload, Retrieve ConfigValue History Download by ConfigValueId
     * Retrieve ConfigValue History Download by ConfigValueId
     * @param ConfigValueId Enter ConfigValueId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConfigValueHistoryDownloadConfigValueIdPost(
        ConfigValueId: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<any>;
    public orgMgrV1ConfigValueHistoryDownloadConfigValueIdPost(
        ConfigValueId: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1ConfigValueHistoryDownloadConfigValueIdPost(
        ConfigValueId: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1ConfigValueHistoryDownloadConfigValueIdPost(
        ConfigValueId: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (ConfigValueId === null || ConfigValueId === undefined) {
            throw new Error(
                'Required parameter ConfigValueId was null or undefined when calling orgMgrV1ConfigValueHistoryDownloadConfigValueIdPost.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/csv'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.post<any>(
            `${this.basePath}/OrgMgr/V1/ConfigValue/History/Download/${encodeURIComponent(String(ConfigValueId))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_RetrieveConfigHistory, Retrieve  Config History
     * Retrieve Config History based on ConfigId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConfigValueHistoryPost(
        Request: ConfigValueHistoryRetrieveRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConfigValueHistoryResponseInfo>;
    public orgMgrV1ConfigValueHistoryPost(
        Request: ConfigValueHistoryRetrieveRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConfigValueHistoryResponseInfo>>;
    public orgMgrV1ConfigValueHistoryPost(
        Request: ConfigValueHistoryRetrieveRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConfigValueHistoryResponseInfo>>;
    public orgMgrV1ConfigValueHistoryPost(
        Request: ConfigValueHistoryRetrieveRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConfigValueHistoryPost.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConfigValueHistoryResponseInfo>(
            `${this.basePath}/OrgMgr/V1/ConfigValue/History`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_DeleteConfigValue, Delete the requested Config Value
     * Delete the requested Org Config
     * @param Id Enter the Org Config Id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConfigValueIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrV1ConfigValueIdDelete(
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1ConfigValueIdDelete(
        Id: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1ConfigValueIdDelete(
        Id: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1ConfigValueIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/V1/ConfigValue/${encodeURIComponent(String(Id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveConfigValue, Get the Config Value based on Id
     * Get the Config Value based on Id
     * @param Id Enter the Org Config id that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConfigValueIdGet(
        Id: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConfigValueResponseInfo2>;
    public orgMgrV1ConfigValueIdGet(
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConfigValueResponseInfo2>>;
    public orgMgrV1ConfigValueIdGet(
        Id: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConfigValueResponseInfo2>>;
    public orgMgrV1ConfigValueIdGet(
        Id: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1ConfigValueIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ConfigValueResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/ConfigValue/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_UpdateConfigValue, Update a Config Value
     * Update a Config Value
     * @param Id Enter the Org Config id that needs to be updated
     * @param Request Enter the body that should be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConfigValueIdPatch(
        Id: number,
        Request: ConfigValueUpdateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConfigValueResponseInfo2>;
    public orgMgrV1ConfigValueIdPatch(
        Id: number,
        Request: ConfigValueUpdateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConfigValueResponseInfo2>>;
    public orgMgrV1ConfigValueIdPatch(
        Id: number,
        Request: ConfigValueUpdateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConfigValueResponseInfo2>>;
    public orgMgrV1ConfigValueIdPatch(
        Id: number,
        Request: ConfigValueUpdateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1ConfigValueIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConfigValueIdPatch.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<ConfigValueResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/ConfigValue/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateConfigValue, Create a Config Value
     * Create a Config Value
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConfigValuePost(
        Request: ConfigValueCreateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConfigValueResponseInfo>;
    public orgMgrV1ConfigValuePost(
        Request: ConfigValueCreateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConfigValueResponseInfo>>;
    public orgMgrV1ConfigValuePost(
        Request: ConfigValueCreateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConfigValueResponseInfo>>;
    public orgMgrV1ConfigValuePost(
        Request: ConfigValueCreateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1ConfigValuePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConfigValueResponseInfo>(`${this.basePath}/OrgMgr/V1/ConfigValue`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveConfigValueByKey, Get the Config Value based on Keys
     * Get the Config Value based on Keys
     * @param request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConfigValueRetrievePost(
        request: ConfigValueRetriveByKeysRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConfigValueRetriveByKeysResponseInfo>;
    public orgMgrV1ConfigValueRetrievePost(
        request: ConfigValueRetriveByKeysRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConfigValueRetriveByKeysResponseInfo>>;
    public orgMgrV1ConfigValueRetrievePost(
        request: ConfigValueRetriveByKeysRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConfigValueRetriveByKeysResponseInfo>>;
    public orgMgrV1ConfigValueRetrievePost(
        request: ConfigValueRetriveByKeysRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (request === null || request === undefined) {
            throw new Error(
                'Required parameter request was null or undefined when calling orgMgrV1ConfigValueRetrievePost.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConfigValueRetriveByKeysResponseInfo>(
            `${this.basePath}/OrgMgr/V1/ConfigValue/Retrieve`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerAccountAuthentication, Get AccountDetails and Authentication
     * Get AccountDetails, Authentication, Consumer details, notification and autopay based on given parameters
     * @param OrgId Enter the OrgId
     * @param Request Enter the Account specific information in the JSON format.
     * @param Locale Enter the Locale, default is en_US
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerAccountAuthenticatePost(
        OrgId: number,
        Request: ConsumerDataRequestMap,
        Locale?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<AccountDetailResponseMap>;
    public orgMgrV1ConsumerAccountAuthenticatePost(
        OrgId: number,
        Request: ConsumerDataRequestMap,
        Locale?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<AccountDetailResponseMap>>;
    public orgMgrV1ConsumerAccountAuthenticatePost(
        OrgId: number,
        Request: ConsumerDataRequestMap,
        Locale?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<AccountDetailResponseMap>>;
    public orgMgrV1ConsumerAccountAuthenticatePost(
        OrgId: number,
        Request: ConsumerDataRequestMap,
        Locale?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerAccountAuthenticatePost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConsumerAccountAuthenticatePost.',
            );
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (Locale !== undefined) {
            queryParameters = queryParameters.set('Locale', <any>Locale);
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AccountDetailResponseMap>(
            `${this.basePath}/OrgMgr/V1/Consumer/Account/Authenticate`,
            Request,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateConsumerLink, Create Consumer Link
     * Create Consumer Link
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the Account specific information in the JSON format.
     * @param Locale Enter the Locale, default is en_US
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerAccountLinkPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerLinkRequestMap,
        Locale?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerLinkResponseMap>;
    public orgMgrV1ConsumerAccountLinkPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerLinkRequestMap,
        Locale?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerLinkResponseMap>>;
    public orgMgrV1ConsumerAccountLinkPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerLinkRequestMap,
        Locale?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerLinkResponseMap>>;
    public orgMgrV1ConsumerAccountLinkPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerLinkRequestMap,
        Locale?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerAccountLinkPost.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerAccountLinkPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConsumerAccountLinkPost.',
            );
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (Locale !== undefined) {
            queryParameters = queryParameters.set('Locale', <any>Locale);
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConsumerLinkResponseMap>(
            `${this.basePath}/OrgMgr/V1/Consumer/Account/Link`,
            Request,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerUnLink, UnLink the LinkedToConsumer
     * UnLink the LinkedToConsumer
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the Account specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerAccountUnLinkPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerUnLinkRequestMap,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerUnLinkResponseMap>;
    public orgMgrV1ConsumerAccountUnLinkPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerUnLinkRequestMap,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerUnLinkResponseMap>>;
    public orgMgrV1ConsumerAccountUnLinkPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerUnLinkRequestMap,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerUnLinkResponseMap>>;
    public orgMgrV1ConsumerAccountUnLinkPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerUnLinkRequestMap,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerAccountUnLinkPost.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerAccountUnLinkPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConsumerAccountUnLinkPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConsumerUnLinkResponseMap>(
            `${this.basePath}/OrgMgr/V1/Consumer/Account/UnLink`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerActionsData, Retrieve Action cards data
     * Retrieve Action cards data, this end point is used by consumer portal
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerActionDataGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ActionCardData>;
    public orgMgrV1ConsumerActionDataGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ActionCardData>>;
    public orgMgrV1ConsumerActionDataGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ActionCardData>>;
    public orgMgrV1ConsumerActionDataGet(
        OrgId: number,
        ConsumerNumber: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerActionDataGet.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerActionDataGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ActionCardData>(`${this.basePath}/OrgMgr/V1/Consumer/Action/Data`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_ConsumerActions, Retrieve Action cards
     * Retrieve Action cards, this end point is used by consumer portal
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerActionGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerActionResponse>;
    public orgMgrV1ConsumerActionGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerActionResponse>>;
    public orgMgrV1ConsumerActionGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerActionResponse>>;
    public orgMgrV1ConsumerActionGet(
        OrgId: number,
        ConsumerNumber: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerActionGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerActionGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ConsumerActionResponse>(`${this.basePath}/OrgMgr/V1/Consumer/Action`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_ConsumerActivityData, Retrieve activity data
     * Retrieve activity data
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param request Enter the Consumer specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerActivityDataPost(
        ConsumerNumber: string,
        OrgId: string,
        request: Request4,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ActivityResponseInfoList2>;
    public orgMgrV1ConsumerActivityDataPost(
        ConsumerNumber: string,
        OrgId: string,
        request: Request4,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ActivityResponseInfoList2>>;
    public orgMgrV1ConsumerActivityDataPost(
        ConsumerNumber: string,
        OrgId: string,
        request: Request4,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ActivityResponseInfoList2>>;
    public orgMgrV1ConsumerActivityDataPost(
        ConsumerNumber: string,
        OrgId: string,
        request: Request4,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerActivityDataPost.',
            );
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerActivityDataPost.',
            );
        }
        if (request === null || request === undefined) {
            throw new Error(
                'Required parameter request was null or undefined when calling orgMgrV1ConsumerActivityDataPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ActivityResponseInfoList2>(
            `${this.basePath}/OrgMgr/V1/Consumer/Activity/Data`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerActivityDetailDynamic, Retrieve activity details
     * Retrieve activity details for given RelatedEntity and RelatedEntityId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param request Enter the Consumer specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerActivityDetailPost(
        ConsumerNumber: string,
        OrgId: string,
        request: Request6,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ActivityResponseInfoList5>;
    public orgMgrV1ConsumerActivityDetailPost(
        ConsumerNumber: string,
        OrgId: string,
        request: Request6,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ActivityResponseInfoList5>>;
    public orgMgrV1ConsumerActivityDetailPost(
        ConsumerNumber: string,
        OrgId: string,
        request: Request6,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ActivityResponseInfoList5>>;
    public orgMgrV1ConsumerActivityDetailPost(
        ConsumerNumber: string,
        OrgId: string,
        request: Request6,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerActivityDetailPost.',
            );
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerActivityDetailPost.',
            );
        }
        if (request === null || request === undefined) {
            throw new Error(
                'Required parameter request was null or undefined when calling orgMgrV1ConsumerActivityDetailPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ActivityResponseInfoList5>(
            `${this.basePath}/OrgMgr/V1/ConsumerActivity/Detail`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerActivityDetail, Retrieve activity details
     * Retrieve activity details for given Consumer Acitivity Id
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param Id Enter the Id for which Consumer Activity needs to be retrieved
     * @param DataSource Enter the DataSource. Allowed values are Portal and External
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerActivityIdDetailGet(
        ConsumerNumber: string,
        OrgId: string,
        Id: number,
        DataSource: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ActivityResponseInfoList4>;
    public orgMgrV1ConsumerActivityIdDetailGet(
        ConsumerNumber: string,
        OrgId: string,
        Id: number,
        DataSource: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ActivityResponseInfoList4>>;
    public orgMgrV1ConsumerActivityIdDetailGet(
        ConsumerNumber: string,
        OrgId: string,
        Id: number,
        DataSource: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ActivityResponseInfoList4>>;
    public orgMgrV1ConsumerActivityIdDetailGet(
        ConsumerNumber: string,
        OrgId: string,
        Id: number,
        DataSource: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerActivityIdDetailGet.',
            );
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerActivityIdDetailGet.',
            );
        }
        if (Id === null || Id === undefined) {
            throw new Error(
                'Required parameter Id was null or undefined when calling orgMgrV1ConsumerActivityIdDetailGet.',
            );
        }
        if (DataSource === null || DataSource === undefined) {
            throw new Error(
                'Required parameter DataSource was null or undefined when calling orgMgrV1ConsumerActivityIdDetailGet.',
            );
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (DataSource !== undefined) {
            queryParameters = queryParameters.set('DataSource', <any>DataSource);
        }

        let headers = this.defaultHeaders;
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ActivityResponseInfoList4>(
            `${this.basePath}/OrgMgr/V1/ConsumerActivity/${encodeURIComponent(String(Id))}/Detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateConsumerActivity, Create consumer activity
     * Create consumer activity
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerActivityPost(
        ConsumerNumber: string,
        OrgId: string,
        Request: ConsumerActityCreateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerActityCreateResponseInfo>;
    public orgMgrV1ConsumerActivityPost(
        ConsumerNumber: string,
        OrgId: string,
        Request: ConsumerActityCreateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerActityCreateResponseInfo>>;
    public orgMgrV1ConsumerActivityPost(
        ConsumerNumber: string,
        OrgId: string,
        Request: ConsumerActityCreateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerActityCreateResponseInfo>>;
    public orgMgrV1ConsumerActivityPost(
        ConsumerNumber: string,
        OrgId: string,
        Request: ConsumerActityCreateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerActivityPost.',
            );
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerActivityPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConsumerActivityPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConsumerActityCreateResponseInfo>(
            `${this.basePath}/OrgMgr/V1/ConsumerActivity`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerActivity, Retrieve activity
     * Retrieve activity
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param request Enter the Consumer specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerActivityPost_1(
        ConsumerNumber: string,
        OrgId: string,
        request: Request5,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ActivityResponseInfoList3>;
    public orgMgrV1ConsumerActivityPost_1(
        ConsumerNumber: string,
        OrgId: string,
        request: Request5,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ActivityResponseInfoList3>>;
    public orgMgrV1ConsumerActivityPost_1(
        ConsumerNumber: string,
        OrgId: string,
        request: Request5,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ActivityResponseInfoList3>>;
    public orgMgrV1ConsumerActivityPost_1(
        ConsumerNumber: string,
        OrgId: string,
        request: Request5,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerActivityPost_1.',
            );
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerActivityPost_1.',
            );
        }
        if (request === null || request === undefined) {
            throw new Error(
                'Required parameter request was null or undefined when calling orgMgrV1ConsumerActivityPost_1.',
            );
        }

        let headers = this.defaultHeaders;
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ActivityResponseInfoList3>(
            `${this.basePath}/OrgMgr/V1/Consumer/Activity`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateConsumerActivityProcess, Invoke consumer activity process
     * Invoke consumer activity process to save in Consumer Activity table
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerActivityProcessPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerActityCreateRequestInfo2,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerActityCreateResponseInfo2>;
    public orgMgrV1ConsumerActivityProcessPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerActityCreateRequestInfo2,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerActityCreateResponseInfo2>>;
    public orgMgrV1ConsumerActivityProcessPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerActityCreateRequestInfo2,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerActityCreateResponseInfo2>>;
    public orgMgrV1ConsumerActivityProcessPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerActityCreateRequestInfo2,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerActivityProcessPost.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerActivityProcessPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConsumerActivityProcessPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConsumerActityCreateResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/ConsumerActivity/Process`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerActivityQueueReProcess, Reprocessing the ConsumerActivity Queue
     * Reprocessing the ConsumerActivity Queue which are not success
     * @param Id Enter the Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerActivityQueueIdPost(
        Id: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerActityCreateResponseInfo3>;
    public orgMgrV1ConsumerActivityQueueIdPost(
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerActityCreateResponseInfo3>>;
    public orgMgrV1ConsumerActivityQueueIdPost(
        Id: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerActityCreateResponseInfo3>>;
    public orgMgrV1ConsumerActivityQueueIdPost(
        Id: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error(
                'Required parameter Id was null or undefined when calling orgMgrV1ConsumerActivityQueueIdPost.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.post<ConsumerActityCreateResponseInfo3>(
            `${this.basePath}/OrgMgr/V1/ConsumerActivityQueue/${encodeURIComponent(String(Id))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerAttributes, Get all attributes pertaining to given consumer
     * Get all attributes pertaining to given consumer
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the Consumer Number
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerAttributesGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerAttributesRespInfo>;
    public orgMgrV1ConsumerAttributesGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerAttributesRespInfo>>;
    public orgMgrV1ConsumerAttributesGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerAttributesRespInfo>>;
    public orgMgrV1ConsumerAttributesGet(
        OrgId: number,
        ConsumerNumber: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerAttributesGet.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerAttributesGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ConsumerAttributesRespInfo>(`${this.basePath}/OrgMgr/V1/Consumer/Attributes`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_ConsumerAutoPayEnroll,
     * ConsumerAutoPayEnroll
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerAutoPayEnrollPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<AutoPayEnrollResponse>;
    public orgMgrV1ConsumerAutoPayEnrollPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<AutoPayEnrollResponse>>;
    public orgMgrV1ConsumerAutoPayEnrollPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<AutoPayEnrollResponse>>;
    public orgMgrV1ConsumerAutoPayEnrollPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerAutoPayEnrollPost.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerAutoPayEnrollPost.',
            );
        }
        if (request === null || request === undefined) {
            throw new Error(
                'Required parameter request was null or undefined when calling orgMgrV1ConsumerAutoPayEnrollPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AutoPayEnrollResponse>(
            `${this.basePath}/OrgMgr/V1/Consumer/AutoPay/Enroll`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerAutoPayEnrolled,
     * ConsumerAutoPayEnrolled
     * @param OrgId Enter the OrgId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerAutoPayEnrolledGet(
        OrgId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<AutoPayEnrollResponse5>;
    public orgMgrV1ConsumerAutoPayEnrolledGet(
        OrgId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<AutoPayEnrollResponse5>>;
    public orgMgrV1ConsumerAutoPayEnrolledGet(
        OrgId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<AutoPayEnrollResponse5>>;
    public orgMgrV1ConsumerAutoPayEnrolledGet(
        OrgId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerAutoPayEnrolledGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<AutoPayEnrollResponse5>(`${this.basePath}/OrgMgr/V1/Consumer/AutoPay/Enrolled`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveAutoPayExecution, Retrieve autopay execution
     * Retrieve autopay execution
     * @param Id Enter the Id
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerAutoPayExecutionIdGet(
        Id: number,
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<AutoPayEnrollResponse4>;
    public orgMgrV1ConsumerAutoPayExecutionIdGet(
        Id: number,
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<AutoPayEnrollResponse4>>;
    public orgMgrV1ConsumerAutoPayExecutionIdGet(
        Id: number,
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<AutoPayEnrollResponse4>>;
    public orgMgrV1ConsumerAutoPayExecutionIdGet(
        Id: number,
        OrgId: number,
        ConsumerNumber: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error(
                'Required parameter Id was null or undefined when calling orgMgrV1ConsumerAutoPayExecutionIdGet.',
            );
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerAutoPayExecutionIdGet.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerAutoPayExecutionIdGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<AutoPayEnrollResponse4>(
            `${this.basePath}/OrgMgr/V1/Consumer/AutoPay/Execution/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerAutoPayExecution,
     * ConsumerAutoPayExecution
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerAutoPayExecutionPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest3,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<AutoPayEnrollResponse3>;
    public orgMgrV1ConsumerAutoPayExecutionPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest3,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<AutoPayEnrollResponse3>>;
    public orgMgrV1ConsumerAutoPayExecutionPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest3,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<AutoPayEnrollResponse3>>;
    public orgMgrV1ConsumerAutoPayExecutionPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest3,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerAutoPayExecutionPost.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerAutoPayExecutionPost.',
            );
        }
        if (request === null || request === undefined) {
            throw new Error(
                'Required parameter request was null or undefined when calling orgMgrV1ConsumerAutoPayExecutionPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AutoPayEnrollResponse3>(
            `${this.basePath}/OrgMgr/V1/Consumer/AutoPay/Execution`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerAutoPayUnEnroll,
     * ConsumerAutoPayUnEnroll
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerAutoPayUnEnrollPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest2,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<AutoPayEnrollResponse2>;
    public orgMgrV1ConsumerAutoPayUnEnrollPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest2,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<AutoPayEnrollResponse2>>;
    public orgMgrV1ConsumerAutoPayUnEnrollPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest2,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<AutoPayEnrollResponse2>>;
    public orgMgrV1ConsumerAutoPayUnEnrollPost(
        OrgId: number,
        ConsumerNumber: string,
        request: AutoPayEnrollRequest2,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerAutoPayUnEnrollPost.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerAutoPayUnEnrollPost.',
            );
        }
        if (request === null || request === undefined) {
            throw new Error(
                'Required parameter request was null or undefined when calling orgMgrV1ConsumerAutoPayUnEnrollPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AutoPayEnrollResponse2>(
            `${this.basePath}/OrgMgr/V1/Consumer/AutoPay/UnEnroll`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ChangeRequest, Change request
     * Change request
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the ChangeRequest specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerChangeRequestPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ChangeRequestRequest,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ChangeRequestResponse>;
    public orgMgrV1ConsumerChangeRequestPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ChangeRequestRequest,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ChangeRequestResponse>>;
    public orgMgrV1ConsumerChangeRequestPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ChangeRequestRequest,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ChangeRequestResponse>>;
    public orgMgrV1ConsumerChangeRequestPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ChangeRequestRequest,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerChangeRequestPost.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerChangeRequestPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConsumerChangeRequestPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ChangeRequestResponse>(
            `${this.basePath}/OrgMgr/V1/Consumer/ChangeRequest`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateDataCollection, Create DataCollection
     * Validate CaptchaResponse and create DataCollection
     * @param OrgId Enter the OrgId
     * @param Request Enter the Token specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerDataCollectionPost(
        OrgId: number,
        Request: ConsumerDataRequest,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerDataResponse>;
    public orgMgrV1ConsumerDataCollectionPost(
        OrgId: number,
        Request: ConsumerDataRequest,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerDataResponse>>;
    public orgMgrV1ConsumerDataCollectionPost(
        OrgId: number,
        Request: ConsumerDataRequest,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerDataResponse>>;
    public orgMgrV1ConsumerDataCollectionPost(
        OrgId: number,
        Request: ConsumerDataRequest,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerDataCollectionPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConsumerDataCollectionPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConsumerDataResponse>(
            `${this.basePath}/OrgMgr/V1/Consumer/DataCollection`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerData, Get ConsumerData
     * Get ConsumerData based on given ConsumerNumber and OrgId
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerDataGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerDataResponseMap>;
    public orgMgrV1ConsumerDataGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerDataResponseMap>>;
    public orgMgrV1ConsumerDataGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerDataResponseMap>>;
    public orgMgrV1ConsumerDataGet(
        OrgId: number,
        ConsumerNumber: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerDataGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerDataGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ConsumerDataResponseMap>(`${this.basePath}/OrgMgr/V1/Consumer/Data`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveConsumer, Retrieve Consumer
     * Retrieve Consumer
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerRetrieveResponse>;
    public orgMgrV1ConsumerGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerRetrieveResponse>>;
    public orgMgrV1ConsumerGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerRetrieveResponse>>;
    public orgMgrV1ConsumerGet(
        OrgId: number,
        ConsumerNumber: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ConsumerRetrieveResponse>(`${this.basePath}/OrgMgr/V1/Consumer`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_InActivateConsumer, Update Consumer
     * Update Consumer
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the Consumer specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerInActivatePatch(
        OrgId: number,
        ConsumerNumber: string,
        Request: Request1,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<InactiveResponse>;
    public orgMgrV1ConsumerInActivatePatch(
        OrgId: number,
        ConsumerNumber: string,
        Request: Request1,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<InactiveResponse>>;
    public orgMgrV1ConsumerInActivatePatch(
        OrgId: number,
        ConsumerNumber: string,
        Request: Request1,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<InactiveResponse>>;
    public orgMgrV1ConsumerInActivatePatch(
        OrgId: number,
        ConsumerNumber: string,
        Request: Request1,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerInActivatePatch.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerInActivatePatch.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConsumerInActivatePatch.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<InactiveResponse>(`${this.basePath}/OrgMgr/V1/Consumer/InActivate`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_UpdateConsumer, Update Consumer
     * Update Consumer
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the Consumer specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerPatch(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerPatchRequest,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerCreateResponse>;
    public orgMgrV1ConsumerPatch(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerPatchRequest,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerCreateResponse>>;
    public orgMgrV1ConsumerPatch(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerPatchRequest,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerCreateResponse>>;
    public orgMgrV1ConsumerPatch(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerPatchRequest,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerPatch.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerPatch.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1ConsumerPatch.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<ConsumerCreateResponse>(`${this.basePath}/OrgMgr/V1/Consumer`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_ConsumerPaymentAgreement, Retrieve Payment agreement
     * Retrieve Payment agreement, this end point is used by consumer portal
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerPaymentAgreementGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<PaymentAgreementResponse>;
    public orgMgrV1ConsumerPaymentAgreementGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<PaymentAgreementResponse>>;
    public orgMgrV1ConsumerPaymentAgreementGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<PaymentAgreementResponse>>;
    public orgMgrV1ConsumerPaymentAgreementGet(
        OrgId: number,
        ConsumerNumber: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerPaymentAgreementGet.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerPaymentAgreementGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<PaymentAgreementResponse>(`${this.basePath}/OrgMgr/V1/Consumer/PaymentAgreement`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_ConsumerPaymentOptions, Retrieve Payment options
     * Retrieve Payment Options, this end point is used by consumer portal
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerPaymentOptionsGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<PaymentOptionResponse>;
    public orgMgrV1ConsumerPaymentOptionsGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<PaymentOptionResponse>>;
    public orgMgrV1ConsumerPaymentOptionsGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<PaymentOptionResponse>>;
    public orgMgrV1ConsumerPaymentOptionsGet(
        OrgId: number,
        ConsumerNumber: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerPaymentOptionsGet.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerPaymentOptionsGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<PaymentOptionResponse>(`${this.basePath}/OrgMgr/V1/Consumer/PaymentOptions`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetreivePaymentOptionsWithNewLineItems, Retrieve Payment options
     * Retrieve Payment Options with new/additiona LineItems, this end point is used by consumer portal
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the LineItems
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerPaymentOptionsPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: PaymentOptionRequest,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<PaymentOptionResponse>;
    public orgMgrV1ConsumerPaymentOptionsPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: PaymentOptionRequest,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<PaymentOptionResponse>>;
    public orgMgrV1ConsumerPaymentOptionsPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: PaymentOptionRequest,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<PaymentOptionResponse>>;
    public orgMgrV1ConsumerPaymentOptionsPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: PaymentOptionRequest,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerPaymentOptionsPost.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerPaymentOptionsPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConsumerPaymentOptionsPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PaymentOptionResponse>(
            `${this.basePath}/OrgMgr/V1/Consumer/PaymentOptions`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ConsumerPaymentPlan, Retrieve Payment plan
     * Retrieve Payment plan, this end point is used by consumer portal
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerPaymentPlanGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<PaymentPlanResponse>;
    public orgMgrV1ConsumerPaymentPlanGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<PaymentPlanResponse>>;
    public orgMgrV1ConsumerPaymentPlanGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<PaymentPlanResponse>>;
    public orgMgrV1ConsumerPaymentPlanGet(
        OrgId: number,
        ConsumerNumber: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerPaymentPlanGet.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerPaymentPlanGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<PaymentPlanResponse>(`${this.basePath}/OrgMgr/V1/Consumer/PaymentPlan`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_ConsumerPaymentPlanOptions, Retrieve Payment plan options
     * Retrieve Payment plan options, this end point is used by consumer portal
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter template specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerPaymentPlanOptionsPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: Request2,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<PaymentPlanOptionsResponse>;
    public orgMgrV1ConsumerPaymentPlanOptionsPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: Request2,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<PaymentPlanOptionsResponse>>;
    public orgMgrV1ConsumerPaymentPlanOptionsPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: Request2,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<PaymentPlanOptionsResponse>>;
    public orgMgrV1ConsumerPaymentPlanOptionsPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: Request2,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerPaymentPlanOptionsPost.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerPaymentPlanOptionsPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConsumerPaymentPlanOptionsPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PaymentPlanOptionsResponse>(
            `${this.basePath}/OrgMgr/V1/Consumer/PaymentPlanOptions`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateConsumer, Create a Consumer
     * Consumer Create is used by ClientAdmin only
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the consumer details specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerCreateInputRequest,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerCreateResponse>;
    public orgMgrV1ConsumerPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerCreateInputRequest,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerCreateResponse>>;
    public orgMgrV1ConsumerPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerCreateInputRequest,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerCreateResponse>>;
    public orgMgrV1ConsumerPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: ConsumerCreateInputRequest,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1ConsumerPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConsumerCreateResponse>(`${this.basePath}/OrgMgr/V1/Consumer`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_ConsumerRegistration, Consumer Registration
     * Consumer Registration used by ClientAdmin only
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerRegistrationGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerRegistrationResponse>;
    public orgMgrV1ConsumerRegistrationGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerRegistrationResponse>>;
    public orgMgrV1ConsumerRegistrationGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerRegistrationResponse>>;
    public orgMgrV1ConsumerRegistrationGet(
        OrgId: number,
        ConsumerNumber: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerRegistrationGet.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerRegistrationGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ConsumerRegistrationResponse>(`${this.basePath}/OrgMgr/V1/Consumer/Registration`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_SmartActionsRetrieve, Get the configuration for smart actions
     * Get the configuration for smart actions
     * @param ConsumerNumber Enter the Consumer number
     * @param OrgId Enter the OrgId
     * @param PageName Enter the Page name
     * @param SegmentCode Enter the Segment code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerSmartActionGet(
        ConsumerNumber: string,
        OrgId: number,
        PageName: string,
        SegmentCode?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<SmartActionsResponse>;
    public orgMgrV1ConsumerSmartActionGet(
        ConsumerNumber: string,
        OrgId: number,
        PageName: string,
        SegmentCode?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<SmartActionsResponse>>;
    public orgMgrV1ConsumerSmartActionGet(
        ConsumerNumber: string,
        OrgId: number,
        PageName: string,
        SegmentCode?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<SmartActionsResponse>>;
    public orgMgrV1ConsumerSmartActionGet(
        ConsumerNumber: string,
        OrgId: number,
        PageName: string,
        SegmentCode?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerSmartActionGet.',
            );
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerSmartActionGet.',
            );
        }
        if (PageName === null || PageName === undefined) {
            throw new Error(
                'Required parameter PageName was null or undefined when calling orgMgrV1ConsumerSmartActionGet.',
            );
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (PageName !== undefined) {
            queryParameters = queryParameters.set('PageName', <any>PageName);
        }
        if (SegmentCode !== undefined) {
            queryParameters = queryParameters.set('SegmentCode', <any>SegmentCode);
        }

        let headers = this.defaultHeaders;
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<SmartActionsResponse>(`${this.basePath}/OrgMgr/V1/Consumer/SmartAction`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_SmartActionsRetrieveGlobal, Get the configuration for smart actions
     * Get the configuration for smart actions Global
     * @param OrgId Enter the OrgId
     * @param PageName Enter the Page name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerSmartActionGlobalGet(
        OrgId: number,
        PageName: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<SmartActionsResponse2>;
    public orgMgrV1ConsumerSmartActionGlobalGet(
        OrgId: number,
        PageName: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<SmartActionsResponse2>>;
    public orgMgrV1ConsumerSmartActionGlobalGet(
        OrgId: number,
        PageName: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<SmartActionsResponse2>>;
    public orgMgrV1ConsumerSmartActionGlobalGet(
        OrgId: number,
        PageName: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerSmartActionGlobalGet.',
            );
        }
        if (PageName === null || PageName === undefined) {
            throw new Error(
                'Required parameter PageName was null or undefined when calling orgMgrV1ConsumerSmartActionGlobalGet.',
            );
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (PageName !== undefined) {
            queryParameters = queryParameters.set('PageName', <any>PageName);
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<SmartActionsResponse2>(`${this.basePath}/OrgMgr/V1/Consumer/SmartAction/Global`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_ConsumerTokenAuthentication, Authenticate with resettoken and Altcredential
     * Authenticate consumer with resettoken and Altcredential
     * @param OrgId Enter the OrgId
     * @param Request Enter the Token specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerTokenAuthenticatePost(
        OrgId: number,
        Request: ConsumerTokenAuthRequest,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ConsumerTokenAuthResponse>;
    public orgMgrV1ConsumerTokenAuthenticatePost(
        OrgId: number,
        Request: ConsumerTokenAuthRequest,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ConsumerTokenAuthResponse>>;
    public orgMgrV1ConsumerTokenAuthenticatePost(
        OrgId: number,
        Request: ConsumerTokenAuthRequest,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ConsumerTokenAuthResponse>>;
    public orgMgrV1ConsumerTokenAuthenticatePost(
        OrgId: number,
        Request: ConsumerTokenAuthRequest,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerTokenAuthenticatePost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1ConsumerTokenAuthenticatePost.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ConsumerTokenAuthResponse>(
            `${this.basePath}/OrgMgr/V1/Consumer/Token/Authenticate`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_VerificationCheck, Verification link to login back to portal
     * Verification link to login back to portal
     * @param TokenId Enter the Token id that needs to be verified
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerVerificationCheckTokenIdGet(
        TokenId: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<VerificationCheckResponse>;
    public orgMgrV1ConsumerVerificationCheckTokenIdGet(
        TokenId: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<VerificationCheckResponse>>;
    public orgMgrV1ConsumerVerificationCheckTokenIdGet(
        TokenId: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<VerificationCheckResponse>>;
    public orgMgrV1ConsumerVerificationCheckTokenIdGet(
        TokenId: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (TokenId === null || TokenId === undefined) {
            throw new Error(
                'Required parameter TokenId was null or undefined when calling orgMgrV1ConsumerVerificationCheckTokenIdGet.',
            );
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<VerificationCheckResponse>(
            `${this.basePath}/OrgMgr/V1/Consumer/Verification/Check/${encodeURIComponent(String(TokenId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_VerificationCode, Verify Email and SMS
     * Check Email and SMS verification code
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param Code Enter the Code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerVerificationCodeGet(
        ConsumerNumber: string,
        OrgId: number,
        Code: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<VerificationCheckResponse2>;
    public orgMgrV1ConsumerVerificationCodeGet(
        ConsumerNumber: string,
        OrgId: number,
        Code: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<VerificationCheckResponse2>>;
    public orgMgrV1ConsumerVerificationCodeGet(
        ConsumerNumber: string,
        OrgId: number,
        Code: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<VerificationCheckResponse2>>;
    public orgMgrV1ConsumerVerificationCodeGet(
        ConsumerNumber: string,
        OrgId: number,
        Code: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerVerificationCodeGet.',
            );
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerVerificationCodeGet.',
            );
        }
        if (Code === null || Code === undefined) {
            throw new Error(
                'Required parameter Code was null or undefined when calling orgMgrV1ConsumerVerificationCodeGet.',
            );
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (Code !== undefined) {
            queryParameters = queryParameters.set('Code', <any>Code);
        }

        let headers = this.defaultHeaders;
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<VerificationCheckResponse2>(
            `${this.basePath}/OrgMgr/V1/Consumer/Verification/Code`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_Verification, Create Email or Phone verification
     * Create Email or Phone verification
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerVerificationPost(
        ConsumerNumber: string,
        OrgId: number,
        request: VerificationRequest,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<VerificationResponse>;
    public orgMgrV1ConsumerVerificationPost(
        ConsumerNumber: string,
        OrgId: number,
        request: VerificationRequest,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<VerificationResponse>>;
    public orgMgrV1ConsumerVerificationPost(
        ConsumerNumber: string,
        OrgId: number,
        request: VerificationRequest,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<VerificationResponse>>;
    public orgMgrV1ConsumerVerificationPost(
        ConsumerNumber: string,
        OrgId: number,
        request: VerificationRequest,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1ConsumerVerificationPost.',
            );
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerVerificationPost.',
            );
        }
        if (request === null || request === undefined) {
            throw new Error(
                'Required parameter request was null or undefined when calling orgMgrV1ConsumerVerificationPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<VerificationResponse>(`${this.basePath}/OrgMgr/V1/Consumer/Verification`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveVerification, Retrieve Verification Info
     * Retrieve Verification Info
     * @param OrgId Enter the OrgId
     * @param VerificationId Enter the Verification Id
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ConsumerVerificationVerificationIdGet(
        OrgId: number,
        VerificationId: number,
        ConsumerNumber?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<VerificationRetrieveResponse>;
    public orgMgrV1ConsumerVerificationVerificationIdGet(
        OrgId: number,
        VerificationId: number,
        ConsumerNumber?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<VerificationRetrieveResponse>>;
    public orgMgrV1ConsumerVerificationVerificationIdGet(
        OrgId: number,
        VerificationId: number,
        ConsumerNumber?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<VerificationRetrieveResponse>>;
    public orgMgrV1ConsumerVerificationVerificationIdGet(
        OrgId: number,
        VerificationId: number,
        ConsumerNumber?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1ConsumerVerificationVerificationIdGet.',
            );
        }
        if (VerificationId === null || VerificationId === undefined) {
            throw new Error(
                'Required parameter VerificationId was null or undefined when calling orgMgrV1ConsumerVerificationVerificationIdGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<VerificationRetrieveResponse>(
            `${this.basePath}/OrgMgr/V1/Consumer/Verification/${encodeURIComponent(String(VerificationId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CountryLookup, Get all the Country.
     * Get all the Country.
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1CountryGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<CountryLookupResponseInfo>;
    public orgMgrV1CountryGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<CountryLookupResponseInfo>>;
    public orgMgrV1CountryGet(
        OrgId: number,
        ConsumerNumber: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<CountryLookupResponseInfo>>;
    public orgMgrV1CountryGet(
        OrgId: number,
        ConsumerNumber: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1CountryGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling orgMgrV1CountryGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<CountryLookupResponseInfo>(`${this.basePath}/OrgMgr/V1/Country`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveDbDefinition, Retrieve StoredProcedure or View name based on type
     * Retrieve StoredProcedure or View name based on type
     * @param Type Select the Type. Allowed values are View, StoredProcedure
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DBDefinitionGet(
        Type?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<DbDefinitionResponseList>;
    public orgMgrV1DBDefinitionGet(
        Type?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<DbDefinitionResponseList>>;
    public orgMgrV1DBDefinitionGet(
        Type?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<DbDefinitionResponseList>>;
    public orgMgrV1DBDefinitionGet(
        Type?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (Type !== undefined) {
            queryParameters = queryParameters.set('Type', <any>Type);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<DbDefinitionResponseList>(`${this.basePath}/OrgMgr/V1/DBDefinition`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveDataMap, Get all the DataMaps
     * Get all the DataMaps
     * @param Type Enter the DataMap Type. Allowed values are AccountDataMap, AccountDetailsDataMap, StatementDataMap
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DataMapGet(
        Type?: Array<string>,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<DatamapResponseList>;
    public orgMgrV1DataMapGet(
        Type?: Array<string>,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<DatamapResponseList>>;
    public orgMgrV1DataMapGet(
        Type?: Array<string>,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<DatamapResponseList>>;
    public orgMgrV1DataMapGet(
        Type?: Array<string>,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (Type) {
            Type.forEach((element) => {
                queryParameters = queryParameters.append('Type', <any>element);
            });
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<DatamapResponseList>(`${this.basePath}/OrgMgr/V1/DataMap`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveAllDevice, Retrieve all device
     * Retrieve all device
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DeviceGet(observe?: 'body', reportProgress?: boolean): Observable<DeviceRetrieveAllResponse>;
    public orgMgrV1DeviceGet(
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<DeviceRetrieveAllResponse>>;
    public orgMgrV1DeviceGet(
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<DeviceRetrieveAllResponse>>;
    public orgMgrV1DeviceGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<DeviceRetrieveAllResponse>(`${this.basePath}/OrgMgr/V1/Device`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_DeleteDevice, Delete the requested Device
     * Delete the requested Device
     * @param Id Enter the device id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DeviceIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrV1DeviceIdDelete(
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1DeviceIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public orgMgrV1DeviceIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1DeviceIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/V1/Device/${encodeURIComponent(String(Id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_UpdateDevice, Update a Device
     * Update a Device
     * @param Id Enter the Id for which Device needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DeviceIdPut(
        Id: number,
        Request: DeviceUpdateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<DeviceUpdateResponseInfo>;
    public orgMgrV1DeviceIdPut(
        Id: number,
        Request: DeviceUpdateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<DeviceUpdateResponseInfo>>;
    public orgMgrV1DeviceIdPut(
        Id: number,
        Request: DeviceUpdateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<DeviceUpdateResponseInfo>>;
    public orgMgrV1DeviceIdPut(
        Id: number,
        Request: DeviceUpdateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1DeviceIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1DeviceIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<DeviceUpdateResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Device/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateDevice, Create a Device
     * Create a Device
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DevicePost(
        Request: DeviceCreateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<DeviceCreateResponseInfo>;
    public orgMgrV1DevicePost(
        Request: DeviceCreateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<DeviceCreateResponseInfo>>;
    public orgMgrV1DevicePost(
        Request: DeviceCreateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<DeviceCreateResponseInfo>>;
    public orgMgrV1DevicePost(
        Request: DeviceCreateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1DevicePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<DeviceCreateResponseInfo>(`${this.basePath}/OrgMgr/V1/Device`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_Retrieve_DeviceTerminals, Retrieve by device Id for Terminals
     * Retrieve by device Id for Terminals
     * @param GroupId Enter the GroupId
     * @param DeviceId Enter the DeviceId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DeviceTerminalConfigGet(
        GroupId: number,
        DeviceId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<DeviceResponseInfo>;
    public orgMgrV1DeviceTerminalConfigGet(
        GroupId: number,
        DeviceId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<DeviceResponseInfo>>;
    public orgMgrV1DeviceTerminalConfigGet(
        GroupId: number,
        DeviceId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<DeviceResponseInfo>>;
    public orgMgrV1DeviceTerminalConfigGet(
        GroupId: number,
        DeviceId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1DeviceTerminalConfigGet.',
            );
        }
        if (DeviceId === null || DeviceId === undefined) {
            throw new Error(
                'Required parameter DeviceId was null or undefined when calling orgMgrV1DeviceTerminalConfigGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (DeviceId !== undefined && DeviceId !== null) {
            headers = headers.set('DeviceId', String(DeviceId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<DeviceResponseInfo>(`${this.basePath}/OrgMgr/V1/Device/Terminal/Config`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveAllTerminal, Retrieve all Terminal
     * Retrieve all Terminal
     * @param GroupId Enter the GroupId
     * @param UserId Enter the UserId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DeviceTerminalGet(
        GroupId: number,
        UserId?: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<TerminalResponseInfoList>;
    public orgMgrV1DeviceTerminalGet(
        GroupId: number,
        UserId?: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<TerminalResponseInfoList>>;
    public orgMgrV1DeviceTerminalGet(
        GroupId: number,
        UserId?: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<TerminalResponseInfoList>>;
    public orgMgrV1DeviceTerminalGet(
        GroupId: number,
        UserId?: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1DeviceTerminalGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<TerminalResponseInfoList>(`${this.basePath}/OrgMgr/V1/Device/Terminal`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_DeleteTerminal, Delete the requested Terminal
     * Delete the requested Terminal
     * @param Id Enter the Terminal id that needs to be deleted
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DeviceTerminalIdDelete(
        Id: number,
        GroupId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<any>;
    public orgMgrV1DeviceTerminalIdDelete(
        Id: number,
        GroupId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1DeviceTerminalIdDelete(
        Id: number,
        GroupId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1DeviceTerminalIdDelete(
        Id: number,
        GroupId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1DeviceTerminalIdDelete.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1DeviceTerminalIdDelete.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.delete<any>(
            `${this.basePath}/OrgMgr/V1/Device/Terminal/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_UpdateTerminal, Update a Device Terminal
     * Update a Device Terminal
     * @param Id Enter the Id for which Terminal needs to be updated
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DeviceTerminalIdPatch(
        Id: number,
        GroupId: number,
        Request: TerminalRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<TerminalResponseInfo2>;
    public orgMgrV1DeviceTerminalIdPatch(
        Id: number,
        GroupId: number,
        Request: TerminalRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<TerminalResponseInfo2>>;
    public orgMgrV1DeviceTerminalIdPatch(
        Id: number,
        GroupId: number,
        Request: TerminalRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<TerminalResponseInfo2>>;
    public orgMgrV1DeviceTerminalIdPatch(
        Id: number,
        GroupId: number,
        Request: TerminalRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1DeviceTerminalIdPatch.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1DeviceTerminalIdPatch.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1DeviceTerminalIdPatch.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<TerminalResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/Device/Terminal/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateTerminal, Create a device Terminal
     * Create a device Terminal
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DeviceTerminalPost(
        GroupId: number,
        Request: TerminalRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<TerminalResponseInfo>;
    public orgMgrV1DeviceTerminalPost(
        GroupId: number,
        Request: TerminalRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<TerminalResponseInfo>>;
    public orgMgrV1DeviceTerminalPost(
        GroupId: number,
        Request: TerminalRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<TerminalResponseInfo>>;
    public orgMgrV1DeviceTerminalPost(
        GroupId: number,
        Request: TerminalRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1DeviceTerminalPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1DeviceTerminalPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<TerminalResponseInfo>(`${this.basePath}/OrgMgr/V1/Device/Terminal`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveDeviceTerminalSetting, Retrieve Device Terminal setting
     * Retrieve Device Terminal setting
     * @param GroupId Enter the GroupId
     * @param TerminalId Enter the TerminalId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1DeviceTerminalSettingGet(
        GroupId: number,
        TerminalId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<TerminalDeviceResponseInfo>;
    public orgMgrV1DeviceTerminalSettingGet(
        GroupId: number,
        TerminalId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<TerminalDeviceResponseInfo>>;
    public orgMgrV1DeviceTerminalSettingGet(
        GroupId: number,
        TerminalId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<TerminalDeviceResponseInfo>>;
    public orgMgrV1DeviceTerminalSettingGet(
        GroupId: number,
        TerminalId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1DeviceTerminalSettingGet.',
            );
        }
        if (TerminalId === null || TerminalId === undefined) {
            throw new Error(
                'Required parameter TerminalId was null or undefined when calling orgMgrV1DeviceTerminalSettingGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (TerminalId !== undefined && TerminalId !== null) {
            headers = headers.set('TerminalId', String(TerminalId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<TerminalDeviceResponseInfo>(`${this.basePath}/OrgMgr/V1/Device/Terminal/Setting`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_Encryption, Encrypt and Decrypt
     * Encrypt and Decrypt
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1EncryptionPost(
        Request: EncryptionRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<EncryptionResponseInfo>;
    public orgMgrV1EncryptionPost(
        Request: EncryptionRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<EncryptionResponseInfo>>;
    public orgMgrV1EncryptionPost(
        Request: EncryptionRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<EncryptionResponseInfo>>;
    public orgMgrV1EncryptionPost(
        Request: EncryptionRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1EncryptionPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EncryptionResponseInfo>(`${this.basePath}/OrgMgr/V1/Encryption`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_AddAccessDept, Add access to Facility for given dept
     * If FacilityId passed it will add access to given DeptIds
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityDeptAddAccessPost(
        GroupId: number,
        Request: FacilityDeptAddRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<FacilityDeptAddRespInfo>;
    public orgMgrV1FacilityDeptAddAccessPost(
        GroupId: number,
        Request: FacilityDeptAddRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<FacilityDeptAddRespInfo>>;
    public orgMgrV1FacilityDeptAddAccessPost(
        GroupId: number,
        Request: FacilityDeptAddRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<FacilityDeptAddRespInfo>>;
    public orgMgrV1FacilityDeptAddAccessPost(
        GroupId: number,
        Request: FacilityDeptAddRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1FacilityDeptAddAccessPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1FacilityDeptAddAccessPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<FacilityDeptAddRespInfo>(
            `${this.basePath}/OrgMgr/V1/Facility/Dept/AddAccess`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_RetrieveAllDept, Retrieve All Facility Dept based on Name
     * Search Facility Dept based on Name
     * @param GroupId Enter the GroupId
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityDeptGet(
        GroupId: number,
        FacilityId?: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<FacilityDeptResponseInfoList>;
    public orgMgrV1FacilityDeptGet(
        GroupId: number,
        FacilityId?: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<FacilityDeptResponseInfoList>>;
    public orgMgrV1FacilityDeptGet(
        GroupId: number,
        FacilityId?: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<FacilityDeptResponseInfoList>>;
    public orgMgrV1FacilityDeptGet(
        GroupId: number,
        FacilityId?: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1FacilityDeptGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<FacilityDeptResponseInfoList>(`${this.basePath}/OrgMgr/V1/Facility/Dept`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_DeleteDept, Delete the requested Facility Dept
     * Delete the requested Facility Dept
     * @param GroupId Enter the GroupId
     * @param Id Enter the Facility Dept Id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityDeptIdDelete(
        GroupId: number,
        Id: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<any>;
    public orgMgrV1FacilityDeptIdDelete(
        GroupId: number,
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1FacilityDeptIdDelete(
        GroupId: number,
        Id: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1FacilityDeptIdDelete(
        GroupId: number,
        Id: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1FacilityDeptIdDelete.',
            );
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1FacilityDeptIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.delete<any>(
            `${this.basePath}/OrgMgr/V1/Facility/Dept/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_RetrieveDept, Get the Facility Dept based on Id
     * Get the Facility Dept based on Id
     * @param GroupId Enter the GroupId
     * @param Id Enter the Facility Dept id that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityDeptIdGet(
        GroupId: number,
        Id: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<FacilityDeptRetrieveResponseInfo>;
    public orgMgrV1FacilityDeptIdGet(
        GroupId: number,
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<FacilityDeptRetrieveResponseInfo>>;
    public orgMgrV1FacilityDeptIdGet(
        GroupId: number,
        Id: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<FacilityDeptRetrieveResponseInfo>>;
    public orgMgrV1FacilityDeptIdGet(
        GroupId: number,
        Id: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1FacilityDeptIdGet.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1FacilityDeptIdGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<FacilityDeptRetrieveResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Facility/Dept/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_UpdateDept, Update a Facility Dept
     * Update a Facility Dept
     * @param GroupId Enter the GroupId
     * @param Id Enter the Facility Dept id that needs to be updated
     * @param Request Enter the body that should be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityDeptIdPatch(
        GroupId: number,
        Id: number,
        Request: FacilityDeptUpdateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<FacilityDeptResponseInfo2>;
    public orgMgrV1FacilityDeptIdPatch(
        GroupId: number,
        Id: number,
        Request: FacilityDeptUpdateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<FacilityDeptResponseInfo2>>;
    public orgMgrV1FacilityDeptIdPatch(
        GroupId: number,
        Id: number,
        Request: FacilityDeptUpdateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<FacilityDeptResponseInfo2>>;
    public orgMgrV1FacilityDeptIdPatch(
        GroupId: number,
        Id: number,
        Request: FacilityDeptUpdateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1FacilityDeptIdPatch.',
            );
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1FacilityDeptIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1FacilityDeptIdPatch.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<FacilityDeptResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/Facility/Dept/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_RemoveAccessDept, Remove access to Facility for given dept
     * If FacilityId passed it will delete from FacilityDept
     * @param GroupId Enter the GroupId
     * @param Id Enter the Facility Dept id that needs to be retrieved
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityDeptIdRemoveAccessPut(
        GroupId: number,
        Id: number,
        Request: FacilityDeptRemoveRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<any>;
    public orgMgrV1FacilityDeptIdRemoveAccessPut(
        GroupId: number,
        Id: number,
        Request: FacilityDeptRemoveRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1FacilityDeptIdRemoveAccessPut(
        GroupId: number,
        Id: number,
        Request: FacilityDeptRemoveRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1FacilityDeptIdRemoveAccessPut(
        GroupId: number,
        Id: number,
        Request: FacilityDeptRemoveRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1FacilityDeptIdRemoveAccessPut.',
            );
        }
        if (Id === null || Id === undefined) {
            throw new Error(
                'Required parameter Id was null or undefined when calling orgMgrV1FacilityDeptIdRemoveAccessPut.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1FacilityDeptIdRemoveAccessPut.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(
            `${this.basePath}/OrgMgr/V1/Facility/Dept/${encodeURIComponent(String(Id))}/RemoveAccess`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_UpdateStatusDept, Update the status of Dept
     * Update the status of Dept to Active or Inactive
     * @param GroupId Enter the GroupId
     * @param Id Enter the Facility DeptId that needs to be retrieved
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityDeptIdStatusPatch(
        GroupId: number,
        Id: number,
        Request: FacilityDeptInactiveRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<FacilityDeptInactiveResponseInfo>;
    public orgMgrV1FacilityDeptIdStatusPatch(
        GroupId: number,
        Id: number,
        Request: FacilityDeptInactiveRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<FacilityDeptInactiveResponseInfo>>;
    public orgMgrV1FacilityDeptIdStatusPatch(
        GroupId: number,
        Id: number,
        Request: FacilityDeptInactiveRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<FacilityDeptInactiveResponseInfo>>;
    public orgMgrV1FacilityDeptIdStatusPatch(
        GroupId: number,
        Id: number,
        Request: FacilityDeptInactiveRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1FacilityDeptIdStatusPatch.',
            );
        }
        if (Id === null || Id === undefined) {
            throw new Error(
                'Required parameter Id was null or undefined when calling orgMgrV1FacilityDeptIdStatusPatch.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1FacilityDeptIdStatusPatch.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<FacilityDeptInactiveResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Facility/Dept/${encodeURIComponent(String(Id))}/Status`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateDept, Create a Facility Dept
     * Create a Facility Dept
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityDeptPost(
        GroupId: number,
        Request: FacilityDeptCreateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<FacilityDeptResponseInfo>;
    public orgMgrV1FacilityDeptPost(
        GroupId: number,
        Request: FacilityDeptCreateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<FacilityDeptResponseInfo>>;
    public orgMgrV1FacilityDeptPost(
        GroupId: number,
        Request: FacilityDeptCreateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<FacilityDeptResponseInfo>>;
    public orgMgrV1FacilityDeptPost(
        GroupId: number,
        Request: FacilityDeptCreateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1FacilityDeptPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1FacilityDeptPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<FacilityDeptResponseInfo>(`${this.basePath}/OrgMgr/V1/Facility/Dept`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_SearchDept, Search Facility Dept based on Name
     * Search Facility Dept based on Name
     * @param GroupId Enter the GroupId
     * @param Name Enter the Name of Dept you need to search
     * @param SearchType Enter the SearchType. Allowed values are Contains, StartsWith, EndsWith
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityDeptSearchGet(
        GroupId: number,
        Name: string,
        SearchType?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<FacilityDeptResponseInfoList2>;
    public orgMgrV1FacilityDeptSearchGet(
        GroupId: number,
        Name: string,
        SearchType?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<FacilityDeptResponseInfoList2>>;
    public orgMgrV1FacilityDeptSearchGet(
        GroupId: number,
        Name: string,
        SearchType?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<FacilityDeptResponseInfoList2>>;
    public orgMgrV1FacilityDeptSearchGet(
        GroupId: number,
        Name: string,
        SearchType?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1FacilityDeptSearchGet.',
            );
        }
        if (Name === null || Name === undefined) {
            throw new Error(
                'Required parameter Name was null or undefined when calling orgMgrV1FacilityDeptSearchGet.',
            );
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (Name !== undefined) {
            queryParameters = queryParameters.set('Name', <any>Name);
        }
        if (SearchType !== undefined) {
            queryParameters = queryParameters.set('SearchType', <any>SearchType);
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<FacilityDeptResponseInfoList2>(`${this.basePath}/OrgMgr/V1/Facility/Dept/Search`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveAllOrgFacility, Retrieve All Org Facility based on OrgId
     * Search Org Facility based on OrgId
     * @param OrgId Enter the OrgId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityGet(
        OrgId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<OrgFacilityResponseInfoList>;
    public orgMgrV1FacilityGet(
        OrgId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<OrgFacilityResponseInfoList>>;
    public orgMgrV1FacilityGet(
        OrgId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<OrgFacilityResponseInfoList>>;
    public orgMgrV1FacilityGet(OrgId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1FacilityGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<OrgFacilityResponseInfoList>(`${this.basePath}/OrgMgr/V1/Facility`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_DeleteOrgFacility, Delete the requested Org Facility
     * Delete the requested Org Facility
     * @param OrgId Enter the OrgId
     * @param Id Enter the Org Facility Id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityIdDelete(
        OrgId: number,
        Id: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<any>;
    public orgMgrV1FacilityIdDelete(
        OrgId: number,
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1FacilityIdDelete(
        OrgId: number,
        Id: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1FacilityIdDelete(
        OrgId: number,
        Id: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1FacilityIdDelete.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1FacilityIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/V1/Facility/${encodeURIComponent(String(Id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveOrgFacility, Get the Org Facility based on Id
     * Get the Org Facility based on Id
     * @param OrgId Enter the OrgId
     * @param Id Enter the Org Facility id that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityIdGet(
        OrgId: number,
        Id: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<OrgFacilityRetrieveResponseInfo>;
    public orgMgrV1FacilityIdGet(
        OrgId: number,
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<OrgFacilityRetrieveResponseInfo>>;
    public orgMgrV1FacilityIdGet(
        OrgId: number,
        Id: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<OrgFacilityRetrieveResponseInfo>>;
    public orgMgrV1FacilityIdGet(
        OrgId: number,
        Id: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1FacilityIdGet.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1FacilityIdGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<OrgFacilityRetrieveResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Facility/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_UpdateOrgFacility, Update a Org Facility
     * Update a Org Facility
     * @param OrgId Enter the OrgId
     * @param Id Enter the Org Facility id that needs to be updated
     * @param Request Enter the body that should be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityIdPatch(
        OrgId: number,
        Id: number,
        Request: OrgFacilityUpdateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<OrgFacilityUpdateResponseInfo>;
    public orgMgrV1FacilityIdPatch(
        OrgId: number,
        Id: number,
        Request: OrgFacilityUpdateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<OrgFacilityUpdateResponseInfo>>;
    public orgMgrV1FacilityIdPatch(
        OrgId: number,
        Id: number,
        Request: OrgFacilityUpdateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<OrgFacilityUpdateResponseInfo>>;
    public orgMgrV1FacilityIdPatch(
        OrgId: number,
        Id: number,
        Request: OrgFacilityUpdateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1FacilityIdPatch.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1FacilityIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1FacilityIdPatch.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<OrgFacilityUpdateResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Facility/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateOrgFacility, Create a Org Facility
     * Create a Org Facility
     * @param OrgId Enter the OrgId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1FacilityPost(
        OrgId: number,
        Request: OrgFacilityCreateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<OrgFacilityResponseInfo>;
    public orgMgrV1FacilityPost(
        OrgId: number,
        Request: OrgFacilityCreateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<OrgFacilityResponseInfo>>;
    public orgMgrV1FacilityPost(
        OrgId: number,
        Request: OrgFacilityCreateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<OrgFacilityResponseInfo>>;
    public orgMgrV1FacilityPost(
        OrgId: number,
        Request: OrgFacilityCreateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1FacilityPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1FacilityPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<OrgFacilityResponseInfo>(`${this.basePath}/OrgMgr/V1/Facility`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveAllGroupDevice, Retrieve all groupDevice
     * Retrieve all groupDevice
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupDeviceGet(
        GroupId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupDeviceRetrieveAllResponse>;
    public orgMgrV1GroupDeviceGet(
        GroupId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupDeviceRetrieveAllResponse>>;
    public orgMgrV1GroupDeviceGet(
        GroupId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupDeviceRetrieveAllResponse>>;
    public orgMgrV1GroupDeviceGet(
        GroupId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1GroupDeviceGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<GroupDeviceRetrieveAllResponse>(`${this.basePath}/OrgMgr/V1/GroupDevice`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_DeleteGroupDevice, Delete the requested GroupDevice
     * Delete the requested GroupDevice
     * @param Id Enter the groupDevice id that needs to be deleted
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupDeviceIdDelete(
        Id: number,
        GroupId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<any>;
    public orgMgrV1GroupDeviceIdDelete(
        Id: number,
        GroupId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1GroupDeviceIdDelete(
        Id: number,
        GroupId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1GroupDeviceIdDelete(
        Id: number,
        GroupId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1GroupDeviceIdDelete.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1GroupDeviceIdDelete.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/V1/GroupDevice/${encodeURIComponent(String(Id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_UpdateGroupDevice, Create a UpdateGroupDevice
     * Create a UpdateGroupDevice
     * @param Id Enter the Id for which groupDevice needs to be updated
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupDeviceIdPut(
        Id: number,
        GroupId: number,
        Request: GroupDeviceUpdateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupDeviceUpdateResponseInfo>;
    public orgMgrV1GroupDeviceIdPut(
        Id: number,
        GroupId: number,
        Request: GroupDeviceUpdateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupDeviceUpdateResponseInfo>>;
    public orgMgrV1GroupDeviceIdPut(
        Id: number,
        GroupId: number,
        Request: GroupDeviceUpdateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupDeviceUpdateResponseInfo>>;
    public orgMgrV1GroupDeviceIdPut(
        Id: number,
        GroupId: number,
        Request: GroupDeviceUpdateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1GroupDeviceIdPut.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1GroupDeviceIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1GroupDeviceIdPut.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<GroupDeviceUpdateResponseInfo>(
            `${this.basePath}/OrgMgr/V1/GroupDevice/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateGroupDevice, Create a CreateGroupDevice
     * Create a CreateGroupDevice
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupDevicePost(
        GroupId: number,
        Request: GroupDeviceCreateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupDeviceCreateResponseInfo>;
    public orgMgrV1GroupDevicePost(
        GroupId: number,
        Request: GroupDeviceCreateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupDeviceCreateResponseInfo>>;
    public orgMgrV1GroupDevicePost(
        GroupId: number,
        Request: GroupDeviceCreateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupDeviceCreateResponseInfo>>;
    public orgMgrV1GroupDevicePost(
        GroupId: number,
        Request: GroupDeviceCreateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1GroupDevicePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1GroupDevicePost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<GroupDeviceCreateResponseInfo>(`${this.basePath}/OrgMgr/V1/GroupDevice`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_DefaultGroupDevice, Default Group Device
     * Default Group Device
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupDeviceSetDefaultPut(
        GroupId: number,
        Request: GroupDeviceCreateRequestInfo2,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupDeviceResponseInfoList>;
    public orgMgrV1GroupDeviceSetDefaultPut(
        GroupId: number,
        Request: GroupDeviceCreateRequestInfo2,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupDeviceResponseInfoList>>;
    public orgMgrV1GroupDeviceSetDefaultPut(
        GroupId: number,
        Request: GroupDeviceCreateRequestInfo2,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupDeviceResponseInfoList>>;
    public orgMgrV1GroupDeviceSetDefaultPut(
        GroupId: number,
        Request: GroupDeviceCreateRequestInfo2,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1GroupDeviceSetDefaultPut.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1GroupDeviceSetDefaultPut.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<GroupDeviceResponseInfoList>(
            `${this.basePath}/OrgMgr/V1/GroupDevice/SetDefault`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_SearchGroup, Search the Group by Name
     * Search the Group by Name
     * @param Name Enter the Name of Group you need to search
     * @param SearchType Enter the SearchType. Allowed values are Contains, StartsWith, EndsWith
     * @param IncludeChildren Enter the IncludeChildren indicator. Also to display the subgroups for group name, if true, else list parent group names. Allowed values are false, true
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupGet(
        Name: string,
        SearchType?: string,
        IncludeChildren?: boolean,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupResponseInfoList>;
    public orgMgrV1GroupGet(
        Name: string,
        SearchType?: string,
        IncludeChildren?: boolean,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupResponseInfoList>>;
    public orgMgrV1GroupGet(
        Name: string,
        SearchType?: string,
        IncludeChildren?: boolean,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupResponseInfoList>>;
    public orgMgrV1GroupGet(
        Name: string,
        SearchType?: string,
        IncludeChildren?: boolean,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Name === null || Name === undefined) {
            throw new Error('Required parameter Name was null or undefined when calling orgMgrV1GroupGet.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (Name !== undefined) {
            queryParameters = queryParameters.set('Name', <any>Name);
        }
        if (SearchType !== undefined) {
            queryParameters = queryParameters.set('SearchType', <any>SearchType);
        }
        if (IncludeChildren !== undefined) {
            queryParameters = queryParameters.set('IncludeChildren', <any>IncludeChildren);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<GroupResponseInfoList>(`${this.basePath}/OrgMgr/V1/Group`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_DeleteGroup, Delete the requested Group
     * Delete the requested Group
     * @param GroupId Enter the Group id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupGroupIdDelete(GroupId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrV1GroupGroupIdDelete(
        GroupId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1GroupGroupIdDelete(
        GroupId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1GroupGroupIdDelete(
        GroupId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1GroupGroupIdDelete.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/V1/Group/${encodeURIComponent(String(GroupId))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveGroup, Get the Group based on Id
     * Get the Group based on Id
     * @param GroupId Enter the Group id that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupGroupIdGet(
        GroupId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupResponseInfo2>;
    public orgMgrV1GroupGroupIdGet(
        GroupId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupResponseInfo2>>;
    public orgMgrV1GroupGroupIdGet(
        GroupId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupResponseInfo2>>;
    public orgMgrV1GroupGroupIdGet(
        GroupId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1GroupGroupIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<GroupResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/Group/${encodeURIComponent(String(GroupId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_GroupHierarchy, Search the Group by Name
     * Retrieve the Group Hierarchy based on GroupId
     * @param GroupId Enter the GroupId
     * @param LookUpType Enter the SearchType. Allowed values are Ancestors, Descendants, AncestorsAndDescendants
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupGroupIdHierarchyGet(
        GroupId: number,
        LookUpType?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupHierarchyResponseInfo>;
    public orgMgrV1GroupGroupIdHierarchyGet(
        GroupId: number,
        LookUpType?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupHierarchyResponseInfo>>;
    public orgMgrV1GroupGroupIdHierarchyGet(
        GroupId: number,
        LookUpType?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupHierarchyResponseInfo>>;
    public orgMgrV1GroupGroupIdHierarchyGet(
        GroupId: number,
        LookUpType?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1GroupGroupIdHierarchyGet.',
            );
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (LookUpType !== undefined) {
            queryParameters = queryParameters.set('LookUpType', <any>LookUpType);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<GroupHierarchyResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Group/${encodeURIComponent(String(GroupId))}/Hierarchy`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_RetrieveOrgByGroupId, Retrieves all orgs under the given Groupid ie deep 1 more level
     * Retrieves all orgs under the given Groupid ie deep 1 more level
     * @param GroupId Enter the GroupId for which OrgId needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupGroupIdOrgGet(
        GroupId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<OrgResponseInfoList>;
    public orgMgrV1GroupGroupIdOrgGet(
        GroupId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<OrgResponseInfoList>>;
    public orgMgrV1GroupGroupIdOrgGet(
        GroupId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<OrgResponseInfoList>>;
    public orgMgrV1GroupGroupIdOrgGet(
        GroupId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1GroupGroupIdOrgGet.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<OrgResponseInfoList>(
            `${this.basePath}/OrgMgr/V1/Group/${encodeURIComponent(String(GroupId))}/Org`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_RetrieveParentGroup, Retrieves super parent group whose ParentGroupId is null
     * Retrieves super parent group whose ParentGroupId is null
     * @param GroupId Enter the group id whose parent group need to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupGroupIdParentGet(
        GroupId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupRetrieveAllResponseInfo>;
    public orgMgrV1GroupGroupIdParentGet(
        GroupId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupRetrieveAllResponseInfo>>;
    public orgMgrV1GroupGroupIdParentGet(
        GroupId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupRetrieveAllResponseInfo>>;
    public orgMgrV1GroupGroupIdParentGet(
        GroupId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1GroupGroupIdParentGet.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<GroupRetrieveAllResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Group/${encodeURIComponent(String(GroupId))}/Parent`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_UpdateGroup, Update a Group
     * Update a Group
     * @param GroupId Enter the Group id that needs to be updated
     * @param Request Enter the body that should be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupGroupIdPatch(
        GroupId: number,
        Request: GroupUpdateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupResponseInfo2>;
    public orgMgrV1GroupGroupIdPatch(
        GroupId: number,
        Request: GroupUpdateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupResponseInfo2>>;
    public orgMgrV1GroupGroupIdPatch(
        GroupId: number,
        Request: GroupUpdateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupResponseInfo2>>;
    public orgMgrV1GroupGroupIdPatch(
        GroupId: number,
        Request: GroupUpdateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrV1GroupGroupIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1GroupGroupIdPatch.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<GroupResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/Group/${encodeURIComponent(String(GroupId))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_SubGroup, Retrieves all sub groups for given group id ie deep 1 more level
     * Retrieves all sub groups for given group id ie deep 1 more level
     * @param GroupId Enter the group id whose sub group need to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupGroupIdSubGroupGet(
        GroupId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupRetrieveSubGroupResponseInfo>;
    public orgMgrV1GroupGroupIdSubGroupGet(
        GroupId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupRetrieveSubGroupResponseInfo>>;
    public orgMgrV1GroupGroupIdSubGroupGet(
        GroupId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupRetrieveSubGroupResponseInfo>>;
    public orgMgrV1GroupGroupIdSubGroupGet(
        GroupId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1GroupGroupIdSubGroupGet.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<GroupRetrieveSubGroupResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Group/${encodeURIComponent(String(GroupId))}/SubGroup`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_RetrieveAllParentGroup, Retrieves all the super parent group whose ParentGroupId is null in ascending order
     * Retrieves all the Parent Group whose ParentGroupId is null in ascending order
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupParentGet(
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupRetrieveAllResponseInfo2>;
    public orgMgrV1GroupParentGet(
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupRetrieveAllResponseInfo2>>;
    public orgMgrV1GroupParentGet(
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupRetrieveAllResponseInfo2>>;
    public orgMgrV1GroupParentGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<GroupRetrieveAllResponseInfo2>(`${this.basePath}/OrgMgr/V1/Group/Parent`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_CreateGroup, Create Group
     * Create a Group
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupPost(
        Request: GroupCreateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupResponseInfo>;
    public orgMgrV1GroupPost(
        Request: GroupCreateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupResponseInfo>>;
    public orgMgrV1GroupPost(
        Request: GroupCreateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupResponseInfo>>;
    public orgMgrV1GroupPost(
        Request: GroupCreateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1GroupPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<GroupResponseInfo>(`${this.basePath}/OrgMgr/V1/Group`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveByGroupSiteName, Retrieve By SiteName
     * Retrieve By SiteName
     * @param AppName Enter the AppName
     * @param SiteName Enter the SiteName of Group
     * @param OrgId Enter the Org id that needs to be retrieved
     * @param GroupId Enter the GroupId that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupSiteNameGet(
        AppName: string,
        SiteName?: string,
        OrgId?: number,
        GroupId?: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupResponseSiteNameList>;
    public orgMgrV1GroupSiteNameGet(
        AppName: string,
        SiteName?: string,
        OrgId?: number,
        GroupId?: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupResponseSiteNameList>>;
    public orgMgrV1GroupSiteNameGet(
        AppName: string,
        SiteName?: string,
        OrgId?: number,
        GroupId?: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupResponseSiteNameList>>;
    public orgMgrV1GroupSiteNameGet(
        AppName: string,
        SiteName?: string,
        OrgId?: number,
        GroupId?: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrV1GroupSiteNameGet.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (AppName !== undefined) {
            queryParameters = queryParameters.set('AppName', <any>AppName);
        }
        if (SiteName !== undefined) {
            queryParameters = queryParameters.set('SiteName', <any>SiteName);
        }
        if (OrgId !== undefined) {
            queryParameters = queryParameters.set('OrgId', <any>OrgId);
        }
        if (GroupId !== undefined) {
            queryParameters = queryParameters.set('GroupId', <any>GroupId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<GroupResponseSiteNameList>(`${this.basePath}/OrgMgr/V1/Group/SiteName`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveGroupSubAccount, Get all parent Group SubAccounts
     * Get all parent Group SubAccounts
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1GroupSubAccountGet(
        GroupId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<GroupRetrieveSubAccountRespInfo>;
    public orgMgrV1GroupSubAccountGet(
        GroupId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<GroupRetrieveSubAccountRespInfo>>;
    public orgMgrV1GroupSubAccountGet(
        GroupId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<GroupRetrieveSubAccountRespInfo>>;
    public orgMgrV1GroupSubAccountGet(
        GroupId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error(
                'Required parameter GroupId was null or undefined when calling orgMgrV1GroupSubAccountGet.',
            );
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<GroupRetrieveSubAccountRespInfo>(`${this.basePath}/OrgMgr/V1/Group/SubAccount`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_SearchOrg, Search the Org by Name or OrgId or GroupId
     * Search the Org by Name or OrgId or GroupId
     * @param Name Enter the Name of Org
     * @param SearchType Enter the SearchType. Allowed values are Contains, StartsWith, EndsWith
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1OrgGet(
        Name?: string,
        SearchType?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<OrgResponseInfoList2>;
    public orgMgrV1OrgGet(
        Name?: string,
        SearchType?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<OrgResponseInfoList2>>;
    public orgMgrV1OrgGet(
        Name?: string,
        SearchType?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<OrgResponseInfoList2>>;
    public orgMgrV1OrgGet(
        Name?: string,
        SearchType?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (Name !== undefined) {
            queryParameters = queryParameters.set('Name', <any>Name);
        }
        if (SearchType !== undefined) {
            queryParameters = queryParameters.set('SearchType', <any>SearchType);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<OrgResponseInfoList2>(`${this.basePath}/OrgMgr/V1/Org`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_DeleteOrg, Delete the requested Org
     * Delete the requested Org
     * @param OrgId Enter the Org id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1OrgOrgIdDelete(OrgId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrV1OrgOrgIdDelete(
        OrgId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1OrgOrgIdDelete(
        OrgId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1OrgOrgIdDelete(
        OrgId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1OrgOrgIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/V1/Org/${encodeURIComponent(String(OrgId))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveOrg, Get the Org based on Id
     * Get the Org based on Id
     * @param OrgId Enter the Org id that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1OrgOrgIdGet(OrgId: number, observe?: 'body', reportProgress?: boolean): Observable<OrgResponseInfo2>;
    public orgMgrV1OrgOrgIdGet(
        OrgId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<OrgResponseInfo2>>;
    public orgMgrV1OrgOrgIdGet(
        OrgId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<OrgResponseInfo2>>;
    public orgMgrV1OrgOrgIdGet(OrgId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1OrgOrgIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<OrgResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/Org/${encodeURIComponent(String(OrgId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_UpdateOrg, Update a Org
     * Update a Org
     * @param OrgId Enter the Org id that needs to be updated
     * @param Request Enter the body that should be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1OrgOrgIdPatch(
        OrgId: number,
        Request: OrgUpdateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<OrgResponseInfo2>;
    public orgMgrV1OrgOrgIdPatch(
        OrgId: number,
        Request: OrgUpdateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<OrgResponseInfo2>>;
    public orgMgrV1OrgOrgIdPatch(
        OrgId: number,
        Request: OrgUpdateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<OrgResponseInfo2>>;
    public orgMgrV1OrgOrgIdPatch(
        OrgId: number,
        Request: OrgUpdateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1OrgOrgIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1OrgOrgIdPatch.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<OrgResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/Org/${encodeURIComponent(String(OrgId))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateOrg, Create a Org
     * Create a Org
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1OrgPost(
        Request: OrgCreateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<OrgResponseInfo>;
    public orgMgrV1OrgPost(
        Request: OrgCreateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<OrgResponseInfo>>;
    public orgMgrV1OrgPost(
        Request: OrgCreateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<OrgResponseInfo>>;
    public orgMgrV1OrgPost(
        Request: OrgCreateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1OrgPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<OrgResponseInfo>(`${this.basePath}/OrgMgr/V1/Org`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveBySiteName, Retrieve By SiteName
     * Retrieve By SiteName
     * @param SiteName Enter the SiteName of Org
     * @param AppName Enter the AppName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1OrgSiteNameGet(
        SiteName: string,
        AppName: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<OrgResponseSiteNameList>;
    public orgMgrV1OrgSiteNameGet(
        SiteName: string,
        AppName: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<OrgResponseSiteNameList>>;
    public orgMgrV1OrgSiteNameGet(
        SiteName: string,
        AppName: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<OrgResponseSiteNameList>>;
    public orgMgrV1OrgSiteNameGet(
        SiteName: string,
        AppName: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (SiteName === null || SiteName === undefined) {
            throw new Error('Required parameter SiteName was null or undefined when calling orgMgrV1OrgSiteNameGet.');
        }
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrV1OrgSiteNameGet.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (SiteName !== undefined) {
            queryParameters = queryParameters.set('SiteName', <any>SiteName);
        }
        if (AppName !== undefined) {
            queryParameters = queryParameters.set('AppName', <any>AppName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<OrgResponseSiteNameList>(`${this.basePath}/OrgMgr/V1/Org/SiteName`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveSuperParentGroupByOrgId, Retrieve SuperParentGroupId By passing OrgId
     * Retrieve SuperParentGroupId By passing OrgId
     * @param OrgId Enter the OrgId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1OrgSuperParentGroupOrgIdGet(
        OrgId: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<OrgRetrieveResponseInfo>;
    public orgMgrV1OrgSuperParentGroupOrgIdGet(
        OrgId: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<OrgRetrieveResponseInfo>>;
    public orgMgrV1OrgSuperParentGroupOrgIdGet(
        OrgId: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<OrgRetrieveResponseInfo>>;
    public orgMgrV1OrgSuperParentGroupOrgIdGet(
        OrgId: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1OrgSuperParentGroupOrgIdGet.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<OrgRetrieveResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Org/SuperParentGroup/${encodeURIComponent(String(OrgId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_RetrieveAllPermission, Get all permissions
     * Gives the records of permission
     * @param AppName Enter the AppName
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1PermissionGet(
        AppName: string,
        GroupId?: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<PermissionResponseInfoList>;
    public orgMgrV1PermissionGet(
        AppName: string,
        GroupId?: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<PermissionResponseInfoList>>;
    public orgMgrV1PermissionGet(
        AppName: string,
        GroupId?: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<PermissionResponseInfoList>>;
    public orgMgrV1PermissionGet(
        AppName: string,
        GroupId?: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrV1PermissionGet.');
        }

        let headers = this.defaultHeaders;
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<PermissionResponseInfoList>(`${this.basePath}/OrgMgr/V1/Permission`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_PurgeConsumerData, Purge the consumer data
     * Purge the consumer data
     * @param Request Enter the request values
     * @param GroupId Enter the GroupId
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1PurgePost(
        Request: PurgeDataRequestInfo,
        GroupId?: number,
        OrgId?: number,
        ConsumerNumber?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<any>;
    public orgMgrV1PurgePost(
        Request: PurgeDataRequestInfo,
        GroupId?: number,
        OrgId?: number,
        ConsumerNumber?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1PurgePost(
        Request: PurgeDataRequestInfo,
        GroupId?: number,
        OrgId?: number,
        ConsumerNumber?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1PurgePost(
        Request: PurgeDataRequestInfo,
        GroupId?: number,
        OrgId?: number,
        ConsumerNumber?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1PurgePost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/OrgMgr/V1/Purge`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_GenericSearch, Search generically on Em3 tables
     * Search generically on Em3 tables based on given parameters
     * @param request Enter the Consumer specific information in the JSON format.
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1SearchPost(
        request: Request3,
        GroupId?: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<Array<InlineResponse2003>>;
    public orgMgrV1SearchPost(
        request: Request3,
        GroupId?: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<Array<InlineResponse2003>>>;
    public orgMgrV1SearchPost(
        request: Request3,
        GroupId?: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<Array<InlineResponse2003>>>;
    public orgMgrV1SearchPost(
        request: Request3,
        GroupId?: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling orgMgrV1SearchPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<InlineResponse2003>>(`${this.basePath}/OrgMgr/V1/Search`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_SettingsDownload, Download Settings (SiteSetting/Config) as per level.
     * Download Settings (SiteSettings/Config) as per level. File is ^ separated.
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1SettingDownloadPost(
        Request: DownloadRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<any>;
    public orgMgrV1SettingDownloadPost(
        Request: DownloadRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1SettingDownloadPost(
        Request: DownloadRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1SettingDownloadPost(
        Request: DownloadRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1SettingDownloadPost.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/csv'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/OrgMgr/V1/Setting/Download`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_Sync, Upload settings file for sync
     * Upload settings file for sync
     * @param Level Enter the Level, Allowed values are System, Org and Group. Default System
     * @param Type Enter type, Allowed values are SiteSetting/Config
     * @param File Upload the file here, Max file size allowed is 25Mb
     * @param OrgId Enter the OrgId
     * @param GroupId Enter the GroupId
     * @param FacilityId Enter the FacilityId
     * @param Ids Enter Id. For multiple Ids enter comma separated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1SettingSyncPost(
        Level: string,
        Type: string,
        File: Blob,
        OrgId?: number,
        GroupId?: number,
        FacilityId?: number,
        Ids?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<SyncAndVerificationResponseInfo>;
    public orgMgrV1SettingSyncPost(
        Level: string,
        Type: string,
        File: Blob,
        OrgId?: number,
        GroupId?: number,
        FacilityId?: number,
        Ids?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<SyncAndVerificationResponseInfo>>;
    public orgMgrV1SettingSyncPost(
        Level: string,
        Type: string,
        File: Blob,
        OrgId?: number,
        GroupId?: number,
        FacilityId?: number,
        Ids?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<SyncAndVerificationResponseInfo>>;
    public orgMgrV1SettingSyncPost(
        Level: string,
        Type: string,
        File: Blob,
        OrgId?: number,
        GroupId?: number,
        FacilityId?: number,
        Ids?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Level === null || Level === undefined) {
            throw new Error('Required parameter Level was null or undefined when calling orgMgrV1SettingSyncPost.');
        }
        if (Type === null || Type === undefined) {
            throw new Error('Required parameter Type was null or undefined when calling orgMgrV1SettingSyncPost.');
        }
        if (File === null || File === undefined) {
            throw new Error('Required parameter File was null or undefined when calling orgMgrV1SettingSyncPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['multipart/form-data'];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (Level !== undefined) {
            formParams = formParams.append('Level', <any>Level) || formParams;
        }
        if (OrgId !== undefined) {
            formParams = formParams.append('OrgId', <any>OrgId) || formParams;
        }
        if (GroupId !== undefined) {
            formParams = formParams.append('GroupId', <any>GroupId) || formParams;
        }
        if (FacilityId !== undefined) {
            formParams = formParams.append('FacilityId', <any>FacilityId) || formParams;
        }
        if (Type !== undefined) {
            formParams = formParams.append('Type', <any>Type) || formParams;
        }
        if (Ids !== undefined) {
            formParams = formParams.append('Ids', <any>Ids) || formParams;
        }
        if (File !== undefined) {
            formParams = formParams.append('File', <any>File) || formParams;
        }

        return this.httpClient.post<SyncAndVerificationResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Setting/Sync`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_SyncVerification, Upload settings file for sync and verification
     * Upload settings file for sync and verification
     * @param Level Enter the Level, Allowed values are System, Org and Group. Default System
     * @param Type Enter type, Allowed values are SiteSetting/Config
     * @param File Upload the file here, Max file size allowed is 25Mb
     * @param OrgId Enter the OrgId
     * @param GroupId Enter the GroupId
     * @param FacilityId Enter the FacilityId
     * @param Ids Enter Id. For multiple Ids enter comma separated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1SettingSyncVerificationPost(
        Level: string,
        Type: string,
        File: Blob,
        OrgId?: number,
        GroupId?: number,
        FacilityId?: number,
        Ids?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<SyncAndVerificationResponseInfo>;
    public orgMgrV1SettingSyncVerificationPost(
        Level: string,
        Type: string,
        File: Blob,
        OrgId?: number,
        GroupId?: number,
        FacilityId?: number,
        Ids?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<SyncAndVerificationResponseInfo>>;
    public orgMgrV1SettingSyncVerificationPost(
        Level: string,
        Type: string,
        File: Blob,
        OrgId?: number,
        GroupId?: number,
        FacilityId?: number,
        Ids?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<SyncAndVerificationResponseInfo>>;
    public orgMgrV1SettingSyncVerificationPost(
        Level: string,
        Type: string,
        File: Blob,
        OrgId?: number,
        GroupId?: number,
        FacilityId?: number,
        Ids?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Level === null || Level === undefined) {
            throw new Error(
                'Required parameter Level was null or undefined when calling orgMgrV1SettingSyncVerificationPost.',
            );
        }
        if (Type === null || Type === undefined) {
            throw new Error(
                'Required parameter Type was null or undefined when calling orgMgrV1SettingSyncVerificationPost.',
            );
        }
        if (File === null || File === undefined) {
            throw new Error(
                'Required parameter File was null or undefined when calling orgMgrV1SettingSyncVerificationPost.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['multipart/form-data'];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (Level !== undefined) {
            formParams = formParams.append('Level', <any>Level) || formParams;
        }
        if (OrgId !== undefined) {
            formParams = formParams.append('OrgId', <any>OrgId) || formParams;
        }
        if (GroupId !== undefined) {
            formParams = formParams.append('GroupId', <any>GroupId) || formParams;
        }
        if (FacilityId !== undefined) {
            formParams = formParams.append('FacilityId', <any>FacilityId) || formParams;
        }
        if (Type !== undefined) {
            formParams = formParams.append('Type', <any>Type) || formParams;
        }
        if (Ids !== undefined) {
            formParams = formParams.append('Ids', <any>Ids) || formParams;
        }
        if (File !== undefined) {
            formParams = formParams.append('File', <any>File) || formParams;
        }

        return this.httpClient.post<SyncAndVerificationResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Setting/SyncVerification`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_SettingValidate, Validate SiteSetting/Config based on type
     * Validate SiteSetting/Config based on type
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1SettingValidatePost(
        Request: ValidateSettingRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ValidateSettingResponseInfo>;
    public orgMgrV1SettingValidatePost(
        Request: ValidateSettingRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ValidateSettingResponseInfo>>;
    public orgMgrV1SettingValidatePost(
        Request: ValidateSettingRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ValidateSettingResponseInfo>>;
    public orgMgrV1SettingValidatePost(
        Request: ValidateSettingRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1SettingValidatePost.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ValidateSettingResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Setting/Validate`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_StateLookup, Get all the State for given conutry.
     * Get all the State for given conutry.
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param Country Enter the Country
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1StateGet(
        ConsumerNumber: string,
        OrgId: number,
        Country?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<StateLookupResponseInfo>;
    public orgMgrV1StateGet(
        ConsumerNumber: string,
        OrgId: number,
        Country?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<StateLookupResponseInfo>>;
    public orgMgrV1StateGet(
        ConsumerNumber: string,
        OrgId: number,
        Country?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<StateLookupResponseInfo>>;
    public orgMgrV1StateGet(
        ConsumerNumber: string,
        OrgId: number,
        Country?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling orgMgrV1StateGet.');
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1StateGet.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (Country !== undefined) {
            queryParameters = queryParameters.set('Country', <any>Country);
        }

        let headers = this.defaultHeaders;
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<StateLookupResponseInfo>(`${this.basePath}/OrgMgr/V1/State`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_Survey_RetrieveAll, Get all Survey
     * Get all Survey
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1SurveyGet(observe?: 'body', reportProgress?: boolean): Observable<SurveyRetrieveAllResponseInfo>;
    public orgMgrV1SurveyGet(
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<SurveyRetrieveAllResponseInfo>>;
    public orgMgrV1SurveyGet(
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<SurveyRetrieveAllResponseInfo>>;
    public orgMgrV1SurveyGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<SurveyRetrieveAllResponseInfo>(`${this.basePath}/OrgMgr/V1/Survey`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_Survey_NextQuestion, Next survey question
     * Next survey question
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the Consumer number
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1SurveyNextQuestionPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: SurveyNextQuestionRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<SurveyNextQuestionResponseInfo>;
    public orgMgrV1SurveyNextQuestionPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: SurveyNextQuestionRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<SurveyNextQuestionResponseInfo>>;
    public orgMgrV1SurveyNextQuestionPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: SurveyNextQuestionRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<SurveyNextQuestionResponseInfo>>;
    public orgMgrV1SurveyNextQuestionPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: SurveyNextQuestionRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error(
                'Required parameter OrgId was null or undefined when calling orgMgrV1SurveyNextQuestionPost.',
            );
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1SurveyNextQuestionPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1SurveyNextQuestionPost.',
            );
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SurveyNextQuestionResponseInfo>(
            `${this.basePath}/OrgMgr/V1/Survey/NextQuestion`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_Survey_Begin, To start a survey
     * To start a survey
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the Consumer number
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1SurveyStartPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: SurveyStartRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<SurveyStartResponseInfo>;
    public orgMgrV1SurveyStartPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: SurveyStartRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<SurveyStartResponseInfo>>;
    public orgMgrV1SurveyStartPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: SurveyStartRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<SurveyStartResponseInfo>>;
    public orgMgrV1SurveyStartPost(
        OrgId: number,
        ConsumerNumber: string,
        Request: SurveyStartRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1SurveyStartPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error(
                'Required parameter ConsumerNumber was null or undefined when calling orgMgrV1SurveyStartPost.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1SurveyStartPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SurveyStartResponseInfo>(`${this.basePath}/OrgMgr/V1/Survey/Start`, Request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_URLResolver, Retrieve URL based on hashValue.
     * Retrieve URL based on hashValue
     * @param HashValue Enter the HashValue
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1URLResolverHashValueGet(
        HashValue: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<UrlResolverResponse>;
    public orgMgrV1URLResolverHashValueGet(
        HashValue: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<UrlResolverResponse>>;
    public orgMgrV1URLResolverHashValueGet(
        HashValue: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<UrlResolverResponse>>;
    public orgMgrV1URLResolverHashValueGet(
        HashValue: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (HashValue === null || HashValue === undefined) {
            throw new Error(
                'Required parameter HashValue was null or undefined when calling orgMgrV1URLResolverHashValueGet.',
            );
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<UrlResolverResponse>(
            `${this.basePath}/OrgMgr/V1/URLResolver/${encodeURIComponent(String(HashValue))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_URLShortener, Generate hash based on long URL and send short URL.
     * Generate hash based on long URL and send short URL
     * @param request Enter the request
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param OrgId Enter the OrgId
     * @param GroupId Enter the GroupId
     * @param UserId Enter the UserId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1URLShortenerPost(
        request: UrlShortenerRequest,
        ConsumerNumber?: string,
        OrgId?: number,
        GroupId?: number,
        UserId?: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<UrlShortenerResponse>;
    public orgMgrV1URLShortenerPost(
        request: UrlShortenerRequest,
        ConsumerNumber?: string,
        OrgId?: number,
        GroupId?: number,
        UserId?: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<UrlShortenerResponse>>;
    public orgMgrV1URLShortenerPost(
        request: UrlShortenerRequest,
        ConsumerNumber?: string,
        OrgId?: number,
        GroupId?: number,
        UserId?: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<UrlShortenerResponse>>;
    public orgMgrV1URLShortenerPost(
        request: UrlShortenerRequest,
        ConsumerNumber?: string,
        OrgId?: number,
        GroupId?: number,
        UserId?: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling orgMgrV1URLShortenerPost.');
        }

        let headers = this.defaultHeaders;
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UrlShortenerResponse>(`${this.basePath}/OrgMgr/V1/URLShortener`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_RetrieveAllWebAuthentication, Retrieve All WebAuthentication
     * Retrieve All WebAuthentication
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1WebAuthenticationGet(
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<WebAuthenticationResponseInfoList>;
    public orgMgrV1WebAuthenticationGet(
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<WebAuthenticationResponseInfoList>>;
    public orgMgrV1WebAuthenticationGet(
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<WebAuthenticationResponseInfoList>>;
    public orgMgrV1WebAuthenticationGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<WebAuthenticationResponseInfoList>(`${this.basePath}/OrgMgr/V1/WebAuthentication`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }

    /**
     * OrgMgr_DeleteWebAuthentication, Delete the requested WebAuthentication
     * Delete the requested WebAuthentication
     * @param Id Enter the WebAuthentication Id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1WebAuthenticationIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrV1WebAuthenticationIdDelete(
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<any>>;
    public orgMgrV1WebAuthenticationIdDelete(
        Id: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<any>>;
    public orgMgrV1WebAuthenticationIdDelete(
        Id: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error(
                'Required parameter Id was null or undefined when calling orgMgrV1WebAuthenticationIdDelete.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.delete<any>(
            `${this.basePath}/OrgMgr/V1/WebAuthentication/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_RetrieveWebAuthentication, Retrieve WebAuthentication by passing WebAuthentication Id
     * Retrieve WebAuthentication by passing WebAuthentication Id
     * @param Id Enter the WebAuthenticationId that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1WebAuthenticationIdGet(
        Id: number,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<WebAuthenticationResponseInfo2>;
    public orgMgrV1WebAuthenticationIdGet(
        Id: number,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<WebAuthenticationResponseInfo2>>;
    public orgMgrV1WebAuthenticationIdGet(
        Id: number,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<WebAuthenticationResponseInfo2>>;
    public orgMgrV1WebAuthenticationIdGet(
        Id: number,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrV1WebAuthenticationIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<WebAuthenticationResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/WebAuthentication/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_UpdateWebAuthentication, Update a WebAuthentication
     * Update a WebAuthentication
     * @param Id Enter the WebAuthenticationId that needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1WebAuthenticationIdPatch(
        Id: number,
        Request: WebAuthenticationCreateRequestInfo2,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<WebAuthenticationResponseInfo2>;
    public orgMgrV1WebAuthenticationIdPatch(
        Id: number,
        Request: WebAuthenticationCreateRequestInfo2,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<WebAuthenticationResponseInfo2>>;
    public orgMgrV1WebAuthenticationIdPatch(
        Id: number,
        Request: WebAuthenticationCreateRequestInfo2,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<WebAuthenticationResponseInfo2>>;
    public orgMgrV1WebAuthenticationIdPatch(
        Id: number,
        Request: WebAuthenticationCreateRequestInfo2,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error(
                'Required parameter Id was null or undefined when calling orgMgrV1WebAuthenticationIdPatch.',
            );
        }
        if (Request === null || Request === undefined) {
            throw new Error(
                'Required parameter Request was null or undefined when calling orgMgrV1WebAuthenticationIdPatch.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<WebAuthenticationResponseInfo2>(
            `${this.basePath}/OrgMgr/V1/WebAuthentication/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_CreateWebAuthentication, Create a WebAuthentication
     * Create a WebAuthentication
     * @param request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1WebAuthenticationPost(
        request: WebAuthenticationCreateRequestInfo,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<WebAuthenticationResponseInfo>;
    public orgMgrV1WebAuthenticationPost(
        request: WebAuthenticationCreateRequestInfo,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<WebAuthenticationResponseInfo>>;
    public orgMgrV1WebAuthenticationPost(
        request: WebAuthenticationCreateRequestInfo,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<WebAuthenticationResponseInfo>>;
    public orgMgrV1WebAuthenticationPost(
        request: WebAuthenticationCreateRequestInfo,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (request === null || request === undefined) {
            throw new Error(
                'Required parameter request was null or undefined when calling orgMgrV1WebAuthenticationPost.',
            );
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];
        let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<WebAuthenticationResponseInfo>(
            `${this.basePath}/OrgMgr/V1/WebAuthentication`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            },
        );
    }

    /**
     * OrgMgr_ZipCodeLookup, Get State name, City, Time Zone, Day light saving for given zip code.
     * Get State name, City, Time Zone, Day light saving for given zip code.
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter Consumer number
     * @param ZipCode Enter the zip code
     * @param Country Enter the Country
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1ZipCodeGet(
        OrgId: number,
        ZipCode: string,
        ConsumerNumber?: string,
        Country?: string,
        observe?: 'body',
        reportProgress?: boolean,
    ): Observable<ZipcodeLookupResponseInfo>;
    public orgMgrV1ZipCodeGet(
        OrgId: number,
        ZipCode: string,
        ConsumerNumber?: string,
        Country?: string,
        observe?: 'response',
        reportProgress?: boolean,
    ): Observable<HttpResponse<ZipcodeLookupResponseInfo>>;
    public orgMgrV1ZipCodeGet(
        OrgId: number,
        ZipCode: string,
        ConsumerNumber?: string,
        Country?: string,
        observe?: 'events',
        reportProgress?: boolean,
    ): Observable<HttpEvent<ZipcodeLookupResponseInfo>>;
    public orgMgrV1ZipCodeGet(
        OrgId: number,
        ZipCode: string,
        ConsumerNumber?: string,
        Country?: string,
        observe: any = 'body',
        reportProgress: boolean = false,
    ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrV1ZipCodeGet.');
        }
        if (ZipCode === null || ZipCode === undefined) {
            throw new Error('Required parameter ZipCode was null or undefined when calling orgMgrV1ZipCodeGet.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (ZipCode !== undefined) {
            queryParameters = queryParameters.set('ZipCode', <any>ZipCode);
        }
        if (Country !== undefined) {
            queryParameters = queryParameters.set('Country', <any>Country);
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set(
                'Authorization',
                'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
            );
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys['Authorization']);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = ['application/json'];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = ['application/json'];

        return this.httpClient.get<ZipcodeLookupResponseInfo>(`${this.basePath}/OrgMgr/V1/ZipCode`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
}
